const HPAY_TRANSLATION ={
	en: {
		translation: {
		  "Email must be a valid email address": "Email must be a valid email address",
		  "Email is required": "Email is required",
		  "Password is required": "Password is required",
		  "Please enter correct email and password": "Please enter correct email and password",
		  "No such user or bad password": "No such user or bad password",
		  "Service is currently unavailable. Please try later...": "Service is currently unavailable. Please try later...",
		  "Handshake session expired or not found": "Handshake session expired or not found",
		  "Data mismatch! Please retry registration from beginning!": "Data mismatch! Please retry registration from beginning!",
		  "Password must meet complexity requirements": "Password must meet complexity requirements",
		  "Password confirmation mismatch": "Password confirmation mismatch",
		  "You are temporarily blocked becuse of lot of request is a short time period. Try in a few minutes!": "You are temporarily blocked becuse of lot of request is a short time period. Try in a few minutes!",
		  "Please enter at least 8 characters": "Please enter at least 8 characters",
		  "Please enter at least 1 number": "Please enter at least 1 number",
		  "Please enter at least 1 lowercase letter": "Please enter at least 1 lowercase letter",
		  "Please enter at least 1 uppercase letter": "Please enter at least 1 uppercase letter",
		  "Please enter at least 1 special character": "Please enter at least 1 special character",
		  "Passwords do not match": "Passwords do not match",
		  "Identity verification": "Identity verification",
		  "Please check you email for security code we sent you.": "Please check you email for security code we sent you.",
		  "Error! Please try again or later...": "Error! Please try again or later...",
		  "Could not perform Biometric/WebAuthN verification!": "Could not perform Biometric/WebAuthN verification!",
		  "Reverting to verification over e-mailed security code...": "Reverting to verification over e-mailed security code...",
		  "Biometric/WebAuthN verification failed. You can try other verfication method...": "Biometric/WebAuthN verification failed. You can try other verfication method...",
		  "Could not obtain credentials!": "Could not obtain credentials!",
		  "Access recovery": "Access recovery",
		  "Password reset": "Password reset",
		  "Enter your email, set a new password and confirm it. Then proceed to the identity verification.": "Enter your email, set a new password and confirm it. Then proceed to the identity verification.",
		  "Email address": "Email address",
		  "enter valid email": "enter valid email",
		  "New password": "New password",
		  "Repeat new password": "Repeat new password",
		  "Proceed to identity verification...": "Proceed to identity verification...",
		  "Close": "Close",
		  "Identity verification required": "Identity verification required",
		  "Biometric/WebAuthN verification device selection": "Biometric/WebAuthN verification device selection",
		  "Use current browser": "Use current browser",
		  "Scan this QR code with your mobile phone if you are using your phone as external verification device": "Scan this QR code with your mobile phone if you are using your phone as external verification device",
		  "Equivalent url": "Equivalent url",
		  "Try different identity verification method...": "Try different identity verification method...",
		  "E-mail address verification pending...": "E-mail address verification pending...",
		  "Please check your mailbox for 6-digit security code we sent you. Don't forget to check SPAM/Trash/Junk folders also if you don't find a mail message containing security code in your primary inbox.": "Please check your mailbox for 6-digit security code we sent you. Don't forget to check SPAM/Trash/Junk folders also if you don't find a mail message containing security code in your primary inbox.",
		  "SECURITY CODE": "SECURITY CODE",
		  "Cancel and return to the registration form...": "Cancel and return to the registration form...",
		  "Password": "Password",
		  "Remember me on this browser": "Remember me on this browser",
		  "Forgot password?": "Forgot password?",
		  "Login": "Login",
		  "Please correct your input": "Please correct your input",
		  "Bad email address": "Bad email address",
		  "Bad first or last name": "Bad first or last name",
		  "Specified email already exists": "Specified email already exists",
		  "too short?": "too short?",
		  "too long?": "too long?",
		  "first name is required": "first name is required",
		  "last name is required": "last name is required",
		  "email is required": "email is required",
		  "confrimation of password is required": "confrimation of password is required",
		  "Account data is accepted. You must verify your email address before we finalize you account creation. Please check you email for security code we sent you.": "Account data is accepted. You must verify your email address before we finalize you account creation. Please check you email for security code we sent you.",
		  "Bad response please retry or try later...": "Bad response please retry or try later...",
		  "Account data": "Account data",
		  "First name": "First name",
		  "Last name": "Last name",
		  "Repeat password": "Repeat password",
		  "Biometric/WebAuthN Identity Protection": "Biometric/WebAuthN Identity Protection",
		  "Recommended": "Recommended",
		  "Upon registration setup biometric/webauthn credentials": "Upon registration setup biometric/webauthn credentials",
		  "Register": "Register",
		  "Users closed Google Register Window Or Network Error!": "Users closed Google Register Window Or Network Error!",
		  "Sign In Google": "Sign In Google",
		  "Sign In FaceBook": "Sign In FaceBook",
		  "OR": "OR",
		  "Sign up Google": "Sign up Google",
		  "Sign up FaceBook": "Sign up FaceBook",
		  "Not found": "Not found",
		  "search...": "search...",
		  "Home": "Home",
		  "Logout": "Logout",
		  "New order": "New order",
		  "New subscription": "New subscription",
		  "Waiting for authorization...": "Waiting for authorization...",
		  "Company selection/registration...": "Company selection/registration...",
		  "Site selection/registration...": "Site selection/registration...",
		  "Connected!": "Connected!",
		  "External-device identity verification completed!": "External-device identity verification completed!",
		  "Could not complete identity verification over external-device": "Could not complete identity verification over external-device",
		  "Could not obtain credentials! Try reverting to verification over e-mailed security code...": "Could not obtain credentials! Try reverting to verification over e-mailed security code...",
		  "Biometric/WebAuthN credentials approval on external device...": "Biometric/WebAuthN credentials approval on external device...",
		  "Biometric/WebAuthN authorization over an external device...": "Biometric/WebAuthN authorization over an external device...",
		  "Non-valid/unrecognised request!": "Non-valid/unrecognised request!",
		  "You can close this window": "You can close this window",
		  "Delete company": "Delete company",
		  "Please confirm you want to delete company": "Please confirm you want to delete company",
		  "You might lose important data releted to this company.": "You might lose important data releted to this company.",
		  "Delete": "Delete",
		  "Cancel": "Cancel",
		  "Please create a company": "Please create a company",
		  "Company": "Company",
		  "Create a company": "Create a company",
		  "Address": "Address",
		  "ResNo": "ResNo",
		  "TaxNo": "TaxNo",
		  "Country": "Country",
		  "Error on data load!": "Error on data load!",
		  "Updated!": "Updated!",
		  "Error on data update!": "Error on data update!",
		  "Upload blocked!": "Upload blocked!",
		  "Error on data delete!": "Error on data delete!",
		  "Remove user access": "Remove user access",
		  "Please confirm you want to remove": "Please confirm you want to remove",
		  "access to": "access to",
		  "Remove Access": "Remove Access",
		  "Error during access removal": "Error during access removal",
		  "User with given email was not found": "User with given email was not found",
		  "You can not manage yourself": "You can not manage yourself",
		  "Error adding access for user": "Error adding access for user",
		  "Change POS user role": "Change POS user role",
		  "Please confirm you want change role of": "Please confirm you want change role of",
		  "to": "to",
		  "Only one user can be POS": "Only one user can be POS",
		  "creator": "creator",
		  "therefore current": "therefore current",
		  "will became": "will became",
		  "admin": "admin",
		  "Set new role": "Set new role",
		  "Error changing user role": "Error changing user role",
		  "Please enter valid email address": "Please enter valid email address",
		  "Administrator": "Administrator",
		  "Staff": "Staff",
		  "Company Details": "Company Details",
		  "Back to companies list...": "Back to companies list...",
		  "Details": "Details",
		  "Company Name": "Company Name",
		  "Company Warehouses/Delivery Partners": "Company Warehouses/Delivery Partners",
		  "important if you use shipping": "important if you use shipping",
		  "Identifier": "Identifier",
		  "Name": "Name",
		  "City": "City",
		  "Postal Code": "Postal Code",
		  "Street Name": "Street Name",
		  "Street Number": "Street Number",
		  "Bank Account": "Bank Account",
		  "Tel": "Tel",
		  "Contact Name": "Contact Name",
		  "Default": "Default",
		  "Company users": "Company users",
		  "User": "User",
		  "Telephone": "Telephone",
		  "Role": "Role",
		  "Actions": "Actions",
		  "Remove access": "Remove access",
		  "Set role: staff": "Set role: staff",
		  "Set role: owner": "Set role: owner",
		  "Set role: admin": "Set role: admin",
		  "HPay Support": "HPay Support",
		  "Yourself": "Yourself",
		  "Add user": "Add user",
		  "Add access for a user": "Add access for a user",
		  "Add a user access for the company": "Add a user access for the company",
		  "Make sure that a user you are adding access for has an HolestPay account. If not please instruct him/her to create a account first.": "Make sure that a user you are adding access for has an HolestPay account. If not please instruct him/her to create a account first.",
		  "Email": "Email",
		  "Logo upload": "Logo upload",
		  "Update": "Update",
		  "Too Short!": "Too Short!",
		  "Too Long!": "Too Long!",
		  "Name is required": "Name is required",
		  "Address is required": "Address is required",
		  "Reg Number required": "Reg Number required",
		  "Tax Number required": "Tax Number required",
		  "Country required": "Country required",
		  "The company created successfully!": "The company created successfully!",
		  "Error during company create": "Error during company create",
		  "Company data": "Company data",
		  "Please use .jpg or .png image": "Please use .jpg or .png image",
		  "Create": "Create",
		  "Error during adding of this fiscal/integration method!": "Error during adding of this fiscal/integration method!",
		  "Error: could not add this fiscal/integration method at the moment!": "Error: could not add this fiscal/integration method at the moment!",
		  "Select fiscal/integration method to add...": "Select fiscal/integration method to add...",
		  "Back to site fiscal/integration methods...": "Back to site fiscal/integration methods...",
		  "Info": "Info",
		  "Description": "Description",
		  "Requirements": "Requirements",
		  "ADD": "ADD",
		  "Error during adding of this payment method!": "Error during adding of this payment method!",
		  "Error: could not add this payment method at the moment!": "Error: could not add this payment method at the moment!",
		  "Select payment method to add...": "Select payment method to add...",
		  "Back to site payment methods...": "Back to site payment methods...",
		  "Payment Type": "Payment Type",
		  "Recurring support": "Recurring support",
		  "Is instant?": "Is instant?",
		  "HPay cardform": "HPay cardform",
		  "Known banks/financial institutions": "Known banks/financial institutions",
		  "Yes": "Yes",
		  "No": "No",
		  "Error during adding of this shipping method!": "Error during adding of this shipping method!",
		  "Error: could not add this shipping method at the moment!": "Error: could not add this shipping method at the moment!",
		  "Select shipping method to add...": "Select shipping method to add...",
		  "Back to site shipping methods...": "Back to site shipping methods...",
		  "Welcome!": "Welcome!",
		  "You have no company defined. Please first create a company or wait for the access invite!": "You have no company defined. Please first create a company or wait for the access invite!",
		  "Confirm": "Confirm",
		  "Dashboard": "Dashboard",
		  "Site fiscal/integration method data saved!": "Site fiscal/integration method data saved!",
		  "Error saving site fiscal/integration method data": "Error saving site fiscal/integration method data",
		  "Bad language code. Please use 2-letters code, optionally with extension -cyr!": "Bad language code. Please use 2-letters code, optionally with extension -cyr!",
		  "Remove localization": "Remove localization",
		  "Please confirm you want remove localization": "Please confirm you want remove localization",
		  "Remove": "Remove",
		  "Error loading site fiscal/integration method data": "Error loading site fiscal/integration method data",
		  "Fiscal/integration Methods": "Fiscal/integration Methods",
		  "Fiscal/integration method configuration": "Fiscal/integration method configuration",
		  "LOCALIZATION": "LOCALIZATION",
		  "[DEFAULT]": "[DEFAULT]",
		  "Add": "Add",
		  "Language code": "Language code",
		  "2 letters code": "2 letters code",
		  "Enabled": "Enabled",
		  "List order": "List order",
		  "Method UID": "Method UID",
		  "Should be unique! If you need to re-create POS method (because any reason) it's important you keep this value same": "Should be unique! If you need to re-create POS method (because any reason) it's important you keep this value same",
		  "Process Group": "Process Group",
		  "If multiple methods belong to same process group after one in order generates result rest of them are skipped.": "If multiple methods belong to same process group after one in order generates result rest of them are skipped.",
		  "Save": "Save",
		  "Fiscal/integration method": "Fiscal/integration method",
		  "Order": "Order",
		  "Remove fiscal/integration method": "Remove fiscal/integration method",
		  "Please confirm you want remove fiscal/integration method": "Please confirm you want remove fiscal/integration method",
		  "You may lose important data by deleting this method.": "You may lose important data by deleting this method.",
		  "Fiscal/integration method is deleted": "Fiscal/integration method is deleted",
		  "Error: fiscal/integration method could not be deleted!": "Error: fiscal/integration method could not be deleted!",
		  "Error loading site fiscal/integration methods!": "Error loading site fiscal/integration methods!",
		  "Please select a POS!": "Please select a POS!",
		  "fiscal/e-invoice tax system integration, embedded devices (like carwash coin machines) or external system notifications (production line intstructions)": "fiscal/e-invoice tax system integration, embedded devices (like carwash coin machines) or external system notifications (production line intstructions)",
		  "Add New Fiscal/Integration Method": "Add New Fiscal/Integration Method",
		  "Link": "Link",
		  "Please Select Company": "Please Select Company",
		  "Help": "Help",
		  "Don’t have an account?": "Don’t have an account?",
		  "Seamless site payments | Shipping Automation | Fiscalization": "Seamless site payments | Shipping Automation | Fiscalization",
		  "Error during support ticket creation": "Error during support ticket creation",
		  "Raise a new support ticket": "Raise a new support ticket",
		  "Back to support tickets list...": "Back to support tickets list...",
		  "Support tickets are way to make sure our support receives your support request (since email can be unreliable sometimes). Please allow our team at least 24h to respond.": "Support tickets are way to make sure our support receives your support request (since email can be unreliable sometimes). Please allow our team at least 24h to respond.",
		  "You will be able to describe your problem after ticket creation.": "You will be able to describe your problem after ticket creation.",
		  "Please name your issue": "Please name your issue",
		  "Concerning Company": "Concerning Company",
		  "Concerning POS": "Concerning POS",
		  "Item": "Item",
		  "Type": "Type",
		  "Product": "Product",
		  "Shipping": "Shipping",
		  "Discount": "Discount",
		  "Fee": "Fee",
		  "SKU": "SKU",
		  "Tax%": "Tax%",
		  "Unit Price": "Unit Price",
		  "Qty": "Qty",
		  "Subtotal": "Subtotal",
		  "Virtual": "Virtual",
		  "Warehouse": "Warehouse",
		  "Length (cm)": "Length (cm)",
		  "Width (cm)": "Width (cm)",
		  "Height (cm)": "Height (cm)",
		  "Weight (g)": "Weight (g)",
		  "Order UID": "Order UID",
		  "Amount": "Amount",
		  "Editor": "Editor",
		  "Raw Data View": "Raw Data View",
		  "Order Name": "Order Name",
		  "This order should be managed on-site. Override?": "This order should be managed on-site. Override?",
		  "Currency": "Currency",
		  "Langauge": "Langauge",
		  "Billing": "Billing",
		  "Is Company?": "Is Company?",
		  "Ship to different address?": "Ship to different address?",
		  "Company Tax ID": "Company Tax ID",
		  "Company Registration ID": "Company Registration ID",
		  "Address Line 1": "Address Line 1",
		  "Address Line 2": "Address Line 2",
		  "Postcode": "Postcode",
		  "State": "State",
		  "Phone": "Phone",
		  "Cash on Delivery": "Cash on Delivery",
		  "Order Items": "Order Items",
		  "Please ensure all required item fields are filled correctly.": "Please ensure all required item fields are filled correctly.",
		  "Transactions": "Transactions",
		  "Uid": "Uid",
		  "Created On": "Created On",
		  "Status": "Status",
		  "Pay By Link Options": "Pay By Link Options",
		  "Offer validity days": "Offer validity days",
		  "Pay by link URL": "Pay by link URL",
		  "Copy to clipboard...": "Copy to clipboard...",
		  "-- you forgot to save the order first! --": "-- you forgot to save the order first! --",
		  "Also notify via SMS": "Also notify via SMS",
		  "RSD /SMS": "RSD /SMS",
		  "Payment methods": "Payment methods",
		  "Shipping methods": "Shipping methods",
		  "Loading...": "Loading...",
		  "Could not load payment methods definition": "Could not load payment methods definition",
		  "Could not load shipping methods definition": "Could not load shipping methods definition",
		  "Could not load fiscal/integration methods definition": "Could not load fiscal/integration methods definition",
		  "Nothing found": "Nothing found",
		  "Error during data loading!": "Error during data loading!",
		  "Error during order save": "Error during order save",
		  "Create pay-by-link order": "Create pay-by-link order",
		  "Orders": "Orders",
		  "From date/time": "From date/time",
		  "To date/time": "To date/time",
		  "Load": "Load",
		  "Save and notify": "Save and notify",
		  "Open": "Open",
		  "Ident.": "Ident.",
		  "Customer": "Customer",
		  "Payment": "Payment",
		  "Fiscal": "Fiscal",
		  "Split pay": "Split pay",
		  "Expires": "Expires",
		  "Order details...": "Order details...",
		  "ACTIONS": "ACTIONS",
		  "Site payment method data saved!": "Site payment method data saved!",
		  "Error saving site payment method data": "Error saving site payment method data",
		  "Payment Methods": "Payment Methods",
		  "Payment Method Configuration": "Payment Method Configuration",
		  "Fallback of": "Fallback of",
		  "none": "none",
		  "Payment Method": "Payment Method",
		  "Remove payment method": "Remove payment method",
		  "Please confirm you want remove payment method": "Please confirm you want remove payment method",
		  "Payment method is deleted": "Payment method is deleted",
		  "Error: Payment method could not be deleted!": "Error: Payment method could not be deleted!",
		  "banks/financial instutions payments integrations": "banks/financial instutions payments integrations",
		  "Add New Payment Method": "Add New Payment Method",
		  "Platform Modules": "Platform Modules",
		  "Already have an account?": "Already have an account?",
		  "ID": "ID",
		  "Site Url": "Site Url",
		  "Additional Site Url-s": "Additional Site Url-s",
		  "Date": "Date",
		  "Please select site...": "Please select site...",
		  "Please select a company": "Please select a company",
		  "Create new company...": "Create new company...",
		  "No selected": "No selected",
		  "Selected Company": "Selected Company",
		  "--company not selected--": "--company not selected--",
		  "Selected POS": "Selected POS",
		  "Please Select POS": "Please Select POS",
		  "Add a new POS (site or app or split-pay identifier)...": "Add a new POS (site or app or split-pay identifier)...",
		  "Site shipping method data saved!": "Site shipping method data saved!",
		  "Error saving site shipping method data": "Error saving site shipping method data",
		  "Shipping Methods": "Shipping Methods",
		  "Shipping Method Configuration": "Shipping Method Configuration",
		  "Remove shipping method": "Remove shipping method",
		  "Please confirm you want remove shipping method": "Please confirm you want remove shipping method",
		  "Shipping method is deleted": "Shipping method is deleted",
		  "Error: Shipping method could not be deleted!": "Error: Shipping method could not be deleted!",
		  "Error loading POS shipping methods!": "Error loading POS shipping methods!",
		  "courier systems api integration": "courier systems api integration",
		  "Add New Shipping Method": "Add New Shipping Method",
		  "POS was updated correctly!": "POS was updated correctly!",
		  "HOLEST PURCHASE KEY WAS NOT ACCEPTED!": "HOLEST PURCHASE KEY WAS NOT ACCEPTED!",
		  "POS type is not an site. You can not connect site to different POS types!": "POS type is not an site. You can not connect site to different POS types!",
		  "Site to be connected must be main url or one of auxiliary urls for the selected POS!": "Site to be connected must be main url or one of auxiliary urls for the selected POS!",
		  "Error in site update request!": "Error in site update request!",
		  "Regenerate secret key": "Regenerate secret key",
		  "Please confirm you want to regenerate POS secret key": "Please confirm you want to regenerate POS secret key",
		  "You will lose connection with this POS untill you update secret key with it.": "You will lose connection with this POS untill you update secret key with it.",
		  "Delete site": "Delete site",
		  "Please confirm you want to delete site": "Please confirm you want to delete site",
		  "POS Configuration": "POS Configuration",
		  "type": "type",
		  "Standard": "Standard",
		  "COMPANY": "COMPANY",
		  "URI/Indentifier": "URI/Indentifier",
		  "additional site url-s (one per line)": "additional site url-s (one per line)",
		  "Merchant POS UID": "Merchant POS UID",
		  "POS Secret Key": "POS Secret Key",
		  "Re-generate": "Re-generate",
		  "Instant payment/shipping/fiscal/integation notification url": "Instant payment/shipping/fiscal/integation notification url",
		  "Prefered exchange rate source": "Prefered exchange rate source",
		  "Exchange rate correction % (middle)": "Exchange rate correction % (middle)",
		  "Fixed language (for customers)": "Fixed language (for customers)",
		  "Payment vault token saving policy (when available)": "Payment vault token saving policy (when available)",
		  "Leave as POS requested": "Leave as POS requested",
		  "Never save": "Never save",
		  "Force required": "Force required",
		  "Disable HPay Notifications": "Disable HPay Notifications",
		  "If your site/POS can handle all customer messaging. Note that some messages are required by law!": "If your site/POS can handle all customer messaging. Note that some messages are required by law!",
		  "Use your own SMTP to send customer notifications": "Use your own SMTP to send customer notifications",
		  "Enable if you want to deliver HPay customer mails from your SMTP server. If send fails it will revert to HPay SMTP!": "Enable if you want to deliver HPay customer mails from your SMTP server. If send fails it will revert to HPay SMTP!",
		  "Enter proper SMTP settings!": "Enter proper SMTP settings!",
		  "Send test mail to": "Send test mail to",
		  "Send": "Send",
		  "Test mail was sent however you must confirm successful reception by checking test address inbox!": "Test mail was sent however you must confirm successful reception by checking test address inbox!",
		  "Error in test mail sending!": "Error in test mail sending!",
		  "Enter proper email address!": "Enter proper email address!",
		  "TEST SMTP SEND": "TEST SMTP SEND",
		  "SMTP Host": "SMTP Host",
		  "SMTP Port": "SMTP Port",
		  "SMTP Username": "SMTP Username",
		  "SMTP Password": "SMTP Password",
		  "SMTP Security Protocol": "SMTP Security Protocol",
		  "SSL": "SSL",
		  "TLS": "TLS",
		  "StartTLS": "StartTLS",
		  "SMTP From": "SMTP From",
		  "SMTP From Name": "SMTP From Name",
		  "SMTP Reply To": "SMTP Reply To",
		  "HOLEST Key (purchase key)": "HOLEST Key (purchase key)",
		  "Key expires at": "Key expires at",
		  "not needed for the sandbox mode": "not needed for the sandbox mode",
		  "key you bought on ecommerce.holest.com": "key you bought on ecommerce.holest.com",
		  "ACTIVATED": "ACTIVATED",
		  "Subscriptions": "Subscriptions",
		  "Fiscal/integration/e-invoice": "Fiscal/integration/e-invoice",
		  "Buy a new key...": "Buy a new key...",
		  "Customer support email": "Customer support email",
		  "Customer support telephone": "Customer support telephone",
		  "Customer support notes": "Customer support notes",
		  "enter notes about your customer support": "enter notes about your customer support",
		  "Your payment terms link": "Your payment terms link",
		  "and choose...": "and choose...",
		  "POS uri": "POS uri",
		  "Auxiliary site url-s": "Auxiliary site url-s",
		  "Merchant POS uid": "Merchant POS uid",
		  "HOLESTKey exp.": "HOLESTKey exp.",
		  "enter valid url": "enter valid url",
		  "enter url": "enter url",
		  "Selected site is deleted!": "Selected site is deleted!",
		  "Error during site delete": "Error during site delete",
		  "Error during POS delete": "Error during POS delete",
		  "Please correct your input!": "Please correct your input!",
		  "The POS is added successfully!": "The POS is added successfully!",
		  "Error during POS add": "Error during POS add",
		  "sandbox: key not needed": "sandbox: key not needed",
		  "Please add a POS - Site, App or SplitPay.": "Please add a POS - Site, App or SplitPay.",
		  "Web site": "Web site",
		  "IOS/Android App": "IOS/Android App",
		  "Stand alone split-pay receiver": "Stand alone split-pay receiver",
		  "POS: Sites or Apps or SplitPay receivers": "POS: Sites or Apps or SplitPay receivers",
		  "Add a new POS": "Add a new POS",
		  "Add a POS for": "Add a POS for",
		  "POS type": "POS type",
		  "Standard type is for platforms where you install plugin/module like wooCommerce, OpenCart, Magento, etc..": "Standard type is for platforms where you install plugin/module like wooCommerce, OpenCart, Magento, etc..",
		  "Main site url": "Main site url",
		  "IOS/Android bundle id-s - comma separated": "IOS/Android bundle id-s - comma separated",
		  "Idenificator like": "Idenificator like",
		  "install-air-conditioner": "install-air-conditioner",
		  "donation-j.doe": "donation-j.doe",
		  "joes-currier": "joes-currier",
		  "comma separated, without www. and https://": "comma separated, without www. and https://",
		  "NOTE: for registered sites and apps you can use site UID as split-pay identifier. You need a stand alone split-pay POS only when you don't have your site/app and you need to receive payments only through purhases over your partner's site(s).": "NOTE: for registered sites and apps you can use site UID as split-pay identifier. You need a stand alone split-pay POS only when you don't have your site/app and you need to receive payments only through purhases over your partner's site(s).",
		  "Subscription details...": "Subscription details...",
		  "Issue": "Issue",
		  "Raised by": "Raised by",
		  "Error loaging support ticket list": "Error loaging support ticket list",
		  "Date/Time": "Date/Time",
		  "Issue description": "Issue description",
		  "Concerning company": "Concerning company",
		  "Closed": "Closed",
		  "Error loading support ticket message": "Error loading support ticket message",
		  "Delete support ticket message": "Delete support ticket message",
		  "Please confirm you want remove message": "Please confirm you want remove message",
		  "Delete message": "Delete message",
		  "Message deleted": "Message deleted",
		  "Error: message could not be deleted!": "Error: message could not be deleted!",
		  "Mark resolved": "Mark resolved",
		  "Please confirm you want mark this ticket as resolved": "Please confirm you want mark this ticket as resolved",
		  "Close ticket": "Close ticket",
		  "Error: ticket could not be closed!": "Error: ticket could not be closed!",
		  "Support ticket": "Support ticket",
		  "Ticket time": "Ticket time",
		  "This support ticket is resolved": "This support ticket is resolved",
		  "Message/Issue Description": "Message/Issue Description",
		  "at": "at",
		  "You must select a company so you could raise a new ticket concerning it": "You must select a company so you could raise a new ticket concerning it",
		  "Support tickets": "Support tickets",
		  "Create a new support ticket": "Create a new support ticket",
		  "Transaction details...": "Transaction details...",
		  "ORDER ACTIONS": "ORDER ACTIONS",
		  "Password updated": "Password updated",
		  "Error - password refused": "Error - password refused",
		  "Error - in password update request": "Error - in password update request",
		  "Error - could not update the password": "Error - could not update the password",
		  "Data updated": "Data updated",
		  "Error - could not update the data": "Error - could not update the data",
		  "Error - refused": "Error - refused",
		  "Error - in request": "Error - in request",
		  "Error - could not obtain credential parameters": "Error - could not obtain credential parameters",
		  "Remove biometric/webauthn credential": "Remove biometric/webauthn credential",
		  "Please confirm you want remove credential": "Please confirm you want remove credential",
		  "Credentials over external device added successfully": "Credentials over external device added successfully",
		  "Enter current password": "Enter current password",
		  "No biometric/webauthn credetials exists. When identity verification is required HolestPay will revert method of sending you 6 digit security code over your e-mail. It's recommended thet you use more modern and secure biometric/webauthn methods since they don't involve trasmition of security parameters in clear form over channels that don't guarantee absolute security.": "No biometric/webauthn credetials exists. When identity verification is required HolestPay will revert method of sending you 6 digit security code over your e-mail. It's recommended thet you use more modern and secure biometric/webauthn methods since they don't involve trasmition of security parameters in clear form over channels that don't guarantee absolute security.",
		  "Change password": "Change password",
		  "Pick a new password of at least 8 characters, at least one uppercase letter and at least one number": "Pick a new password of at least 8 characters, at least one uppercase letter and at least one number",
		  "Current password": "Current password",
		  "Add Biometric/WebAuthN Account Verification": "Add Biometric/WebAuthN Account Verification",
		  "Face-Id and fingerprint are biometric credentials and they provide maximal level of reliability for in the process of your identity verification. It's recommended that you use biometric methods when available. Every browser, even on old PC/phone, will enable you to use basic PIN verification.": "Face-Id and fingerprint are biometric credentials and they provide maximal level of reliability for in the process of your identity verification. It's recommended that you use biometric methods when available. Every browser, even on old PC/phone, will enable you to use basic PIN verification.",
		  "Verification device selection": "Verification device selection",
		  "DISCLAMER": "DISCLAMER",
		  "does not store or transmit": "does not store or transmit",
		  "any of your biometric data like Face-Id or Fingerprint. This data is contained in your device OS, and process of verification itslelf is done by your device/PC. Upon successful verification your device will inform our system that your identity is confirmed by providing matching cryptographic signatures.": "any of your biometric data like Face-Id or Fingerprint. This data is contained in your device OS, and process of verification itslelf is done by your device/PC. Upon successful verification your device will inform our system that your identity is confirmed by providing matching cryptographic signatures.",
		  "Account settings": "Account settings",
		  "Back to dashboard...": "Back to dashboard...",
		  "Add Biometric (Fingerprint, Face-Id or PIN) verification": "Add Biometric (Fingerprint, Face-Id or PIN) verification",
		  "Biometric/WebAuthN credentials": "Biometric/WebAuthN credentials",
		  "Device type": "Device type",
		  "Browser": "Browser",
		  "Show path": "Show path",
		  "Go to first page": "Go to first page",
		  "Go to last page": "Go to last page",
		  "Go to next page": "Go to next page",
		  "Go to previous page": "Go to previous page",
		  "Rows per page:": "Rows per page:",
		  "of": "of",
		  "Empty": "Empty",
		  "Clear": "Clear",
		  "Loading…": "Loading…",
		  "No options": "No options",
		  "Pagination navigation": "Pagination navigation",
		  "Go to": "Go to",
		  "page": "page",
		  "__LANGUAGE__": "__LANGUAGE__",
		  "Sites/Apps/SplitPay receivers": "Sites/Apps/SplitPay receivers",
		  "PAYMENT METHODS": "PAYMENT METHODS",
		  "TRANSACTIONS": "TRANSACTIONS",
		  "SUBSCRIPTIONS": "SUBSCRIPTIONS",
		  "PLATFORM MODULES": "PLATFORM MODULES",
		  "TICKETS": "TICKETS",
		  "HELP": "HELP",
		  "DASHBOARD": "DASHBOARD",
		  "Additional Site Url-s (comma separated)": "Additional Site Url-s (comma separated)",
		  "--not selected--": "--not selected--",
		  "Site": "Site",
		  "Select Company": "Select Company",
		  "Please Select Site": "Please Select Site",
		  "Select Site": "Select Site",
		  "Back to list": "Back to list",
		  "Reset": "Reset",
		  "The site is added to the company": "The site is added to the company",
		  "Please add a site.": "Please add a site.",
		  "Add a new site/app/split-pay identifier": "Add a new site/app/split-pay identifier",
		  "Site Details": "Site Details",
		  "Return to site list": "Return to site list",
		  "Site Secret": "Site Secret",
		  "Site Key": "Site Key",
		  "ReGenerate": "ReGenerate",
		  "Action": "Action",
		  "Payment Method Name": "Payment Method Name",
		  "Add PaymentMethod": "Add PaymentMethod",
		  "Selected Payment Methods is added correctly": "Selected Payment Methods is added correctly",
		  "New Payment Methods": "New Payment Methods",
		  "Payments": "Payments",
		  "Transactions Details": "Transactions Details",
		  "UID": "UID",
		  "Subscriptions Details": "Subscriptions Details",
		  "Payment Methods Details": "Payment Methods Details",
		  "Ticket": "Ticket",
		  "New Ticket": "New Ticket",
		  "My Tickets": "My Tickets",
		  "Remember me": "Remember me",
		  "First name required": "First name required",
		  "Last name required": "Last name required",
		  "Localizations": "Localizations",
		  "PAYMENT METHOD LOCALIZATIONS": "PAYMENT METHOD LOCALIZATIONS",
		  "Add Payment Method Localizations": "Add Payment Method Localizations",
		  "Search data...": "Search data...",
		  "Localization": "Localization",
		  "Localization Details": "Localization Details",
		  "Ticket Name": "Ticket Name",
		  "Ticket Details": "Ticket Details",
		  "Mark Resolved": "Mark Resolved",
		  "Selected Site": "Selected Site",
		  "--site/app/split-pay not selected--": "--site/app/split-pay not selected--",
		  "COMPANY_NAME_EXISTS": "COMPANY_NAME_EXISTS",
		  "SITE_EXISTS": "SITE_EXISTS",
		  "SITES/APPS/SplitPay-s": "SITES/APPS/SplitPay-s",
		  "FISCAL/INTEGRATION MODULES": "FISCAL/INTEGRATION MODULES",
		  "SHIPPING METHODS": "SHIPPING METHODS",
		  "ORDERS": "ORDERS",
		  "SUPPORT TICKETS": "SUPPORT TICKETS",
		  "Order ident.": "Order ident.",
		  "Fiscal/integration methods": "Fiscal/integration methods",
		  "Fallback Of": "Fallback Of",
		  "Additional url-s": "Additional url-s",
		  "Upload": "Upload",
		  "Shipping Method": "Shipping Method",
		  "SUBJECT": "SUBJECT",
		  "Delete Support Ticket": "Delete Support Ticket",
		  "Intesa, AIK, Komercijalna(NLB), HALKBANK": "Intesa, AIK, Komercijalna(NLB), HALKBANK",
		  "Bilo koja banka u Republici Serbiji": "Bilo koja banka u Republici Serbiji",
		  "OTP, Raiffeisen, Unicredit ": "OTP, Raiffeisen, Unicredit ",
		  "ALT5PAY": "ALT5PAY",
		  "Unos kartice na samom sajtu i COF subskripcije": "Unos kartice na samom sajtu i COF subskripcije",
		  "E-commerce account with supported bank. Account type must be 3D+API": "E-commerce account with supported bank. Account type must be 3D+API",
		  "Generisanje QR koda za placanje iz aplikacije i ekvivalatne uplatnice": "Generisanje QR koda za placanje iz aplikacije i ekvivalatne uplatnice",
		  "Racun u bilo kojoj banci u Srbiji": "Racun u bilo kojoj banci u Srbiji",
		  "E-commerce account with supported bank": "E-commerce account with supported bank",
		  "Mogucnost placanja kriptovalutama za ino kupce. Vi mozete dobiti samo pravi USD|EUR|CAD nikako kriptovalutu (taj deo je u nadleznosti Alt5Pay-a). Zato nije potrebna nikakva poseba licenca i po zakonu ove uplate se sagledavaju na isti naćin kao i PayPal.": "Mogucnost placanja kriptovalutama za ino kupce. Vi mozete dobiti samo pravi USD|EUR|CAD nikako kriptovalutu (taj deo je u nadleznosti Alt5Pay-a). Zato nije potrebna nikakva poseba licenca i po zakonu ove uplate se sagledavaju na isti naćin kao i PayPal.",
		  "Morate imati otvoren nalog na alt5pay.com. Morate imati EUR|USD račun da bi mogli da dovučete uplate. ": "Morate imati otvoren nalog na alt5pay.com. Morate imati EUR|USD račun da bi mogli da dovučete uplate. ",
		  "Scan this QR code with your mobile phone in order of using your phone as external verification device": "Scan this QR code with your mobile phone in order of using your phone as external verification device",
		  "OS": "OS",
		  "Please set a company logo!": "Please set a company logo!",
		  "Support Ticket Details": "Support Ticket Details",
		  "Back to sites list...": "Back to sites list...",
		  "Additional Site Url-s (one per line)": "Additional Site Url-s (one per line)",
		  "Error during data loading": "Error during data loading",
		  "Error loading site shipping method data": "Error loading site shipping method data",
		  "Error loading site payment methods!": "Error loading site payment methods!",
		  "The Shipping Methods is exist in this site": "The Shipping Methods is exist in this site",
		  "The fiscal/integration methods is exist in this site": "The fiscal/integration methods is exist in this site",
		  "Please set a company logo": "Please set a company logo",
		  "Please add a POS.": "Please add a POS.",
		  "password is required": "password is required",
		  "HolestPay": "HolestPay",
		  "Idenificator like 'install-air-conditioner' or 'donation-j.doe' or 'joes-currier'": "Idenificator like 'install-air-conditioner' or 'donation-j.doe' or 'joes-currier'",
		  "You might lose important data releted to this site.": "You might lose important data releted to this site.",
		  "Only one user can be POS 'creator' therefore current 'creator' will became 'admin'.": "Only one user can be POS 'creator' therefore current 'creator' will became 'admin'.",
		  "Error during changing of ther user role": "Error during changing of ther user role",
		  "staff": "staff",
		  "hpay-support": "hpay-support",
		  "bad value!": "bad value!",
		  "Company Warehouses": "Company Warehouses",
		  "CREATE PAY-BY-LINK": "CREATE PAY-BY-LINK",
		  "Exclude": "Exclude",
		  "Sent":"Sent"
		}
	},
	rs: {
		translation: {
		  "Email must be a valid email address": "Adresa e-pošte mora biti validna adresa e-pošte",
		  "Email is required": "Email je obavezan",
		  "Password is required": "Lozinka je neophodna",
		  "Please enter correct email and password": "Molimo unesite ispravni e-mail i lozinku",
		  "No such user or bad password": "Korisnik ne postoji ili pogrešna lozinka",
		  "Service is currently unavailable. Please try later...": "Servis je trenutno nedostupan. Molimo probajte kasnije...",
		  "Handshake session expired or not found": "Verifikaciona sesija je istekla ili nije nađena",
		  "Data mismatch! Please retry registration from beginning!": "Neslaganje podataka! Molimo probajte registraciju od početka!",
		  "Password must meet complexity requirements": "Lozinka mora zadovoljiti kriterijume kompleksnosti",
		  "Password confirmation mismatch": "Neslaganje potrvde lozinke",
		  "You are temporarily blocked becuse of lot of request is a short time period. Try in a few minutes!": "Privremeno ste blokirani zbog velikog broja zahteva u kratakom vremenskom periodu. Probajte za nekoliko minuta!",
		  "Please enter at least 8 characters": "Molimo unsetite bar 8 karaktera",
		  "Please enter at least 1 number": "Molimo unsetite bar jednu cifru",
		  "Please enter at least 1 lowercase letter": "Molimo unsetite bar jedno malo slovo",
		  "Please enter at least 1 uppercase letter": "Molimo unsetite bar jedno veliko slovo",
		  "Please enter at least 1 special character": "Molimo unsetite bar jedan specijalni karakter",
		  "Passwords do not match": "Lozinke se ne pokapaju",
		  "Identity verification": "Verifikacija identiteta",
		  "Please check you email for security code we sent you.": "Proverite svoju e-poštu za bezbednosni kod koji smo vam poslali.",
		  "Error! Please try again or later...": "Greška! Pokušajte ponovo ili kasnije...",
		  "Could not perform Biometric/WebAuthN verification!": "Nije moguće izvršiti biometrijsku/WebAutһN verifikaciju!",
		  "Reverting to verification over e-mailed security code...": "Vraćanje na verifikaciju preko bezbednosnog koda poslatog e-poštom...",
		  "Biometric/WebAuthN verification failed. You can try other verfication method...": "Biometrijska/VebAutһN verifikacija nije uspela. Možete isprobati drugi metod verifikacije...",
		  "Could not obtain credentials!": "Greška - kredencijali nisu dostupni!",
		  "Access recovery": "Povratak pristupa",
		  "Password reset": "Resetovanje lozinke",
		  "Enter your email, set a new password and confirm it. Then proceed to the identity verification.": "Unesite svoju e-poštu, postavite novu lozinku lozinku i potvrdite je. Zatim nastavite na korak verifikacije identiteta.",
		  "Email address": "Adresa e-pošte",
		  "enter valid email": "Unesite ispravnu e-mail",
		  "New password": "Nova lozinka",
		  "Repeat new password": "Ponovi novu lozinku",
		  "Proceed to identity verification...": "Nastavi na verifikaciju identiteta...",
		  "Close": "Zatvori",
		  "Identity verification required": "Potrebna je verifikacija identiteta",
		  "Biometric/WebAuthN verification device selection": "Odabor uređaja za Biometrisku/WebAuthN verifikaciju",
		  "Use current browser": "Koristi trenutni pretraživač",
		  "Scan this QR code with your mobile phone if you are using your phone as external verification device": "Skenirajte ovaj QR kod svojim mobilnim telefonom ako koristite telefon kao spoljni uređaj za verifikaciju",
		  "Equivalent url": "Ekvivalentni link",
		  "Try different identity verification method...": "Pokušajte dugu metodu verifikacije identiteta...",
		  "E-mail address verification pending...": "Čeka se na potvrdu identiteta preko koda iz e-mail poruke...",
		  "Please check your mailbox for 6-digit security code we sent you. Don't forget to check SPAM/Trash/Junk folders also if you don't find a mail message containing security code in your primary inbox.": "Proverite da li u Vašem poštanskom sandučetu postoji šestocifreni sigurnosni kod koji smo vam poslali. Ne zaboravite da proverite fascikle SPAM/Trash/Junk takođe ako ne pronađete e-poruku koja sadrži sigurnosni kod u svom primarnom prijemnom sandučetu.",
		  "SECURITY CODE": "SIGURNOSNI KOD",
		  "Cancel and return to the registration form...": "Odustani i vrati se na registracionu formu...",
		  "Password": "Lozinka",
		  "Remember me on this browser": "Zapamti me na ovom pretraživaču",
		  "Forgot password?": "Zaboravili ste lozinku?",
		  "Login": "Prijavite se",
		  "Please correct your input": "Ispravite svoj unos",
		  "Bad email address": "Loša adresa e-pošte",
		  "Bad first or last name": "Loše ime ili prezime",
		  "Specified email already exists": "Navedena adresa e-pošte već postoji",
		  "too short?": "prekratko?",
		  "too long?": "predugo?",
		  "first name is required": "ime je obavezno",
		  "last name is required": "prezime je obavezno",
		  "email is required": "e-mail je obavezan",
		  "confrimation of password is required": "potrebna je potvrda lozinke",
		  "Account data is accepted. You must verify your email address before we finalize you account creation. Please check you email for security code we sent you.": "Podaci o nalogu su priһvaćeni. Morate da verifikujete svoju adresu e-pošte pre nego što završimo kreiranje vašeg naloga. Proverite svoju e-poštu za bezbednosni kod koji smo vam poslali.",
		  "Bad response please retry or try later...": "Loš odgovor, pokušajte ponovo ili pokušajte kasnije...",
		  "Account data": "Podaci naloga",
		  "First name": "Ime",
		  "Last name": "Prezime",
		  "First Name": "Ime",
		  "Last Name": "Prezime",
		  "Repeat password": "Potvrda lozinke",
		  "Biometric/WebAuthN Identity Protection": "Biometriska/WebAuthN zaštita Identiteta",
		  "Recommended": "Preporučeno",
		  "Upon registration setup biometric/webauthn credentials": "Po registraciji postavi bimetriske/webauthn kredencijale (otisak prsta, face-id...)",
		  "Register": "Registruj se",
		  "Users closed Google Register Window Or Network Error!": "Korisnici su zatvorili Google prozor za registraciju ili greška mreže!",
		  "Sign In Google": "Google prijava",
		  "Sign In FaceBook": "Facebook prijava",
		  "OR": "ILI",
		  "Sign up Google": "Registracija putem Google-a",
		  "Sign up FaceBook": "Registracija putem Facebook-a",
		  "Not found": "Nije pronađeno",
		  "search...": "traženje...",
		  "Home": "KOMANDNA TABLA",
		  "Logout": "Odjaviti se",
		  "New order": "Nova narudžbina",
		  "New subscription": "Nova pretplata",
		  "Waiting for authorization...": "Čekanje na autorizaciju...",
		  "Company selection/registration...": "Izbor/registracija firme...",
		  "Site selection/registration...": "Izbor/registracija sajta...",
		  "Connected!": "Povezano!",
		  "External-device identity verification completed!": "Verifikacija identiteta spoljnog uređaja je završena!",
		  "Could not complete identity verification over external-device": "Nije moguće završiti verifikaciju identiteta preko spoljnog uređaja",
		  "Could not obtain credentials! Try reverting to verification over e-mailed security code...": "Nije moguće dobiti akreditive! Pokušajte da se vratite na verifikaciju preko bezbednosnog koda poslatog e-poštom...",
		  "Biometric/WebAuthN credentials approval on external device...": "Odobrenje biometrijskiһ/VebAutһN akreditiva na spoljnom uređaju...",
		  "Biometric/WebAuthN authorization over an external device...": "Biometrijska/WebAutһN autorizacija preko spoljnog uređaja...",
		  "Non-valid/unrecognised request!": "Nevažeći/neprepoznat zaһtev!",
		  "You can close this window": "Možete zatvoriti ovu stranicu/prozor",
		  "Delete company": "Brisanje firme",
		  "Please confirm you want to delete company": "Molimo potvrdite brisanje firme",
		  "You might lose important data releted to this company.": "Možete izgubiti važne podatke i sva postavljena podešavanja u vezi sa ovom firmom",
		  "Delete": "Izbriši",
		  "Cancel": "Poništi",
		  "Please create a company": "Molimo dodajte firmu prvo",
		  "Company": "Firma",
		  "Create a company": "Dodaj novu firmu",
		  "Address": "Adresa",
		  "ResNo": "Matični broj",
		  "TaxNo": "PIB",
		  "Country": "Država",
		  "Error on data load!": "Greška pri učitavanju podataka!",
		  "Updated!": "Sačuvano!",
		  "Error on data update!": "Greška pri ažuriranju podataka!",
		  "Upload blocked!": "Otpremanje blokirano!",
		  "Error on data delete!": "Greška pri brisanju podataka!",
		  "Remove user access": "Uklonite pristup korisnika",
		  "Please confirm you want to remove": "Potvrdite da želite da uklonite",
		  "access to": "pristup",
		  "Remove Access": "Uklonite pristup",
		  "Error during access removal": "Greška prilikom uklanjanja pristupa",
		  "User with given email was not found": "Korisnik sa datom e-poštom nije pronađen",
		  "You can not manage yourself": "Ne možete upravljati sobom",
		  "Error adding access for user": "Greška pri dodavanju pristupa za korisnika. Korisnik sa zadatim e-mailom mora prvo napraviti nalog na HPay sistemu!",
		  "Change POS user role": "Promena role naloga za POS",
		  "Please confirm you want change role of": "Molimo potvrdite promenu role za",
		  "to": "u",
		  "Only one user can be POS": "Samo jedan korisnik može biti POS",
		  "creator": "vlasnik",
		  "therefore current": "stoga trenutni",
		  "will became": "postaće",
		  "admin": "admin",
		  "Set new role": "Postavi novu rolu",
		  "Error changing user role": "Greška pri promeni uloge korisnika",
		  "Please enter valid email address": "Molimo unesite ispravnu e-mail adresu",
		  "Administrator": "Administrator",
		  "Staff": "Osoblje",
		  "Company Details": "Detalji firme",
		  "Back to companies list...": "Povratak na listu firmi...",
		  "Details": "Detalji",
		  "Company Name": "Naziv firme",
		  "Company Warehouses/Delivery Partners": "Skladišta/Partneri za dostavu kompanije",
		  "important if you use shipping": "bitno ako koritite module za isporuku",
		  "Identifier": "Identifikator",
		  "Name": "Ime",
		  "City": "Grad",
		  "Postal Code": "Poštanski broj",
		  "Street Name": "Naziv ulice",
		  "Street Number": "Broj u ulici",
		  "Bank Account": "Bankovni račun",
		  "Tel": "Tel",
		  "Contact Name": "Kontakt ime",
		  "Default": "Podrazumevano",
		  "Company users": "Osoblje firme",
		  "User": "Korisnik",
		  "Telephone": "Telefon",
		  "Role": "Rola",
		  "Actions": "Akcije",
		  "Remove access": "Ukoloni pristup",
		  "Set role: staff": "Rola -> osoblje",
		  "Set role: owner": "Rola -> vlasnik",
		  "Set role: admin": "Rola -> admin",
		  "HPay Support": "HPay podrška",
		  "Yourself": "Vi sami",
		  "Add user": "Dodaj korisnika",
		  "Add access for a user": "Dodaj pristup za korisnika",
		  "Add a user access for the company": "Dodaj pristup korisniku za firmu",
		  "Make sure that a user you are adding access for has an HolestPay account. If not please instruct him/her to create a account first.": "Nepohodno je da korisnik kome dajete pristup ima postojeći HolestPay nalog (napomena: sandbox i produkcija ne vide jedno drugo). Ukoliko Vaš sardnik još uvek nama nalog molimo zatražite da ga kreira prvo.",
		  "Email": "Email",
		  "Logo upload": "Otpremanje logo-a",
		  "Update": "Sačuvaj",
		  "Too Short!": "Prekratako!",
		  "Too Long!": "Suviše dugo!",
		  "Name is required": "Ime je obavezno",
		  "Address is required": "Adresa je obavezna",
		  "Reg Number required": "Potreban je registarski broj",
		  "Tax Number required": "Poreski broj je obavezan",
		  "Country required": "Potrebno je navesti zemlju",
		  "The company created successfully!": "Kompanija je uspešno dodata!",
		  "Error during company create": "Greška tokom kreiranja kompanije",
		  "Company data": "Podaci firme",
		  "Please use .jpg or .png image": "Molimo koristite .jpg ili .png sliku",
		  "Create": "Kreiraj",
		  "Error during adding of this fiscal/integration method!": "Greška prilikom dodavanja ovog fiskalnog/integracionog metoda!",
		  "Error: could not add this fiscal/integration method at the moment!": "Greška: trenutno nije moguće dodati ovu fiskalnu metodu!",
		  "Select fiscal/integration method to add...": "Select fiscal/integration method to add...",
		  "Back to site fiscal/integration methods...": "Vrati se na listu fiskalnih/integracionih metoda...",
		  "Info": "Informacije",
		  "Description": "Opis",
		  "Requirements": "Requirements",
		  "ADD": "DODAJ",
		  "Error during adding of this payment method!": "Greška prilikom dodavanja ovog načina plaćanja!",
		  "Error: could not add this payment method at the moment!": "Greška: trenutno nije moguće dodati ovaj način plaćanja!",
		  "Select payment method to add...": "Odaberite platnu metodu za dodavanje...",
		  "Back to site payment methods...": "Povratak na listu metoda plaćanja...",
		  "Payment Type": "Tip plaćanja",
		  "Recurring support": "Podrška za pretplate",
		  "Is instant?": "Instant plaćanje?",
		  "HPay cardform": "HPay unos kartice",
		  "Known banks/financial institutions": "Poznate banke/finansijske institucije",
		  "Yes": "Da",
		  "No": "Ne",
		  "Error during adding of this shipping method!": "Greška prilikom dodavanja ovog načina isporuke!",
		  "Error: could not add this shipping method at the moment!": "Greška: trenutno nije moguće dodati ovaj način isporuke!",
		  "Select shipping method to add...": "Odaberite fiskalnu medodu za dodavanje...",
		  "Back to site shipping methods...": "Povratak na listing medoda isporuke...",
		  "Welcome!": "Dobrodošli!",
		  "You have no company defined. Please first create a company or wait for the access invite!": "Molimo da prvo unesete firmu ili sacekajte da vam dodaju pristup za drugu firmu!",
		  "Confirm": "Potvrdi",
		  "Dashboard": "Komandna tabla",
		  "Site fiscal/integration method data saved!": "Podaci o fiskalnoj metodi sajta su sačuvani!",
		  "Error saving site fiscal/integration method data": "Greška pri čuvanju podataka o fiskalnoj metodi sajta",
		  "Bad language code. Please use 2-letters code, optionally with extension -cyr!": "Loš kod jezika. Molimo koristite kod od 2 mala slova, opciono sa ekstenzijom -cyr!",
		  "Remove localization": "Uklonite lokalizaciju",
		  "Please confirm you want remove localization": "Potvrdite da želite da uklonite lokalizaciju",
		  "Remove": "Ukloni",
		  "Error loading site fiscal/integration method data": "Greška pri učitavanju podataka o fiskalnoj/integracionoj metodi sajta",
		  "Fiscal/integration Methods": "Fiskalne/integracione metode",
		  "Fiscal/integration method configuration": "Konfiguracija fiskalne/integracione metode",
		  "LOCALIZATION": "LOKALIZACIJA",
		  "[DEFAULT]": "[PODRAZUMEVANO]",
		  "Add": "Dodaj",
		  "Language code": "Kod jezika",
		  "2 letters code": "2 slova koda",
		  "Enabled": "Omogućeno",
		  "List order": "Indeks redosleda",
		  "Method UID": "UID metode",
		  "Should be unique! If you need to re-create POS method (because any reason) it's important you keep this value same": "Treba biti unikatna vrednost! Ukoliko morate da re-kreirate metodu za POS (iz bilo kog razloga) važno je da ova vrednost ostane ista",
		  "Process Group": "Procesna grupa",
		  "If multiple methods belong to same process group after one in order generates result rest of them are skipped.": "Ukoliko više metoda pripada istoj procesnoj grupi, i kada jedna u redosledu generise rezultat izvršenje ostalih se preskače",
		  "Save": "Sačuvaj",
		  "Fiscal/integration method": "Fiskalna/integraciona metoda",
		  "Order": "Narudžbina",
		  "Remove fiscal/integration method": "Uklonite fiskalni/integracioni metod",
		  "Please confirm you want remove fiscal/integration method": "Potvrdite da želite da uklonite fiskalni/integracioni metod",
		  "You may lose important data by deleting this method.": "Možete izgubiti važne podatke brisanjem ovog metoda.",
		  "Fiscal/integration method is deleted": "Fiskalni/integracioni metod je izbrisan",
		  "Error: fiscal/integration method could not be deleted!": "Greška: Fiskalni metod nije moguće izbrisati!",
		  "Error loading site fiscal/integration methods!": "Greška pri učitavanju fiskalniһ metoda sajta!",
		  "Please select a POS!": "Molimo daberite POS!",
		  "fiscal/e-invoice tax system integration, embedded devices (like carwash coin machines) or external system notifications (production line intstructions)": "integracija sa poreskim sistemom fiskal/e-faktura, notifikacije za specijalizovane uređaje (poput masina za žetone kod autoperionica) ili notifikacija ka drugim sistemima (npr. pošalji nalog fabrici)",
		  "Add New Fiscal/Integration Method": "Dodaj novu fiskalnu/integracionu metodu",
		  "Link": "Link",
		  "Please Select Company": "Molimo izaberite kompaniju",
		  "Help": "Pomoć",
		  "Don’t have an account?": "Nemate nalog?",
		  "Seamless site payments | Shipping Automation | Fiscalization": "Besprekorni prihvat uplata na sajtu | Automatizacija dostave | Fiskalizacija",
		  "Error during support ticket creation": "Greška tokom kreiranja tiketa za podršku",
		  "Raise a new support ticket": "Kreiraj zahtev za podrškom",
		  "Back to support tickets list...": "Vrati se na listu zahteva za podrškom",
		  "Support tickets are way to make sure our support receives your support request (since email can be unreliable sometimes). Please allow our team at least 24h to respond.": "Zahtevi za podrškom garantuju da će naš tim primiti Vašu poruku (pošto e-pošta ponekad može biti nepouzdana). Dozvolite našem timu 24 sata da odgovori.",
		  "You will be able to describe your problem after ticket creation.": "Detaljan opis problema upisaćete posle kreiranja zahteva.",
		  "Please name your issue": "Molimo naslovite Vaš problem",
		  "Concerning Company": "Tiče se firme",
		  "Concerning POS": "Tiče se POS-a",
		  "Item": "Stavka",
		  "Type": "Tip",
		  "Product": "Proizvod",
		  "Shipping": "Isporuka",
		  "Discount": "Popust",
		  "Fee": "Naknada",
		  "SKU": "SKU",
		  "Tax%": "Porez%",
		  "Unit Price": "Jedinična cena",
		  "Qty": "Količina",
		  "Subtotal": "Međuzbir",
		  "Virtual": "Virtuelno",
		  "Warehouse": "Skladište",
		  "Length (cm)": "Dužina (cm)",
		  "Width (cm)": "Širina (cm)",
		  "Height (cm)": "Visina (cm)",
		  "Weight (g)": "Težina (g)",
		  "Order UID": "UID porudžbine",
		  "Amount": "Iznos",
		  "Editor": "Editor",
		  "Raw Data View": "Prikaz podataka",
		  "Order Name": "Naziv porudžbine",
		  "This order should be managed on-site. Override?": "Ovom porudžbinom bi trebalo da se upravlja na sajtu. Premosti?",
		  "Currency": "Valuta",
		  "Langauge": "Jezik",
		  "Billing": "Naplata",
		  "Is Company?": "Da li je kompanija?",
		  "Ship to different address?": "Dostava na drugu adresu?",
		  "Company Tax ID": "PIB",
		  "Company Registration ID": "Maticni Broj",
		  "Address Line 1": "Adresa Linija 1",
		  "Address Line 2": "Adresa Linija 2",
		  "Postcode": "Poštanski broj",
		  "State": "Država",
		  "Phone": "Telefon",
		  "Cash on Delivery": "Plaćanje pouzećem",
		  "Order Items": "Stavke porudžbine",
		  "Please ensure all required item fields are filled correctly.": "Molimo osigurajte da su sva obavezna polja stavki ispravno popunjena.",
		  "Transactions": "Transakcije",
		  "Uid": "Uid",
		  "Created On": "Vreme kreiranja",
		  "Status": "Status",
		  "Pay By Link Options": "Opcije plaćanja putem linka",
		  "Offer validity days": "Dani važenja ponude",
		  "Pay by link URL": "URL za plaćanje putem linka",
		  "Copy to clipboard...": "Kopiraj u klipbord...",
		  "-- you forgot to save the order first! --": "-- zaboravili ste prvo da sačuvate porudžbinu! --",
		  "Also notify via SMS": "Takođe obavesti putem SMS-a",
		  "RSD /SMS": "RSD /SMS",
		  "Payment methods": "Metode plaćanja",
		  "Shipping methods": "Metode isporuke",
		  "Loading...": "Učitavanje...",
		  "Could not load payment methods definition": "Definicije platnih metoda nisu učitane!",
		  "Could not load shipping methods definition": "Definicije metoda isporuke nisu učitane!",
		  "Could not load fiscal/integration methods definition": "Definicije fiskalnih/integracionih metoda nisu učitane!",
		  "Nothing found": "Ništa nije pronađeno",
		  "Error during data loading!": "Greška pri učitavanju podataka!",
		  "Error during order save": "Greška tokom čuvanja porudžbine",
		  "Create pay-by-link order": "Kreiraj porudžbinu za plaćanje putem linka",
		  "Orders": "Narudžbine",
		  "From date/time": "Datum/vreme od",
		  "To date/time": "Datum/vreme do",
		  "Load": "Učitaj",
		  "Save and notify": "Sačuvaj i obavesti",
		  "Open": "Otvori",
		  "Ident.": "Ident.",
		  "Customer": "Kupac",
		  "Payment": "Placanje",
		  "Fiscal": "Fiskalizaija",
		  "Split pay": "Split pay",
		  "Expires": "Ističe",
		  "Order details...": "Detalji narudžbine...",
		  "ACTIONS": "AKCIJE",
		  "Site payment method data saved!": "Podaci platne metode sačuvani!",
		  "Error saving site payment method data": "Greška pri čuvanju podataka o načinu plaćanja sajta",
		  "Payment Methods": "Načini plaćanja",
		  "Payment Method Configuration": "Payment Method Configuration",
		  "Fallback of": "Fallback of",
		  "none": "nije odabrano",
		  "Payment Method": "Način plaćanja",
		  "Remove payment method": "Uklonite način plaćanja",
		  "Please confirm you want remove payment method": "Potvrdite da želite da uklonite način plaćanja",
		  "Payment method is deleted": "Način plaćanja je izbrisan",
		  "Error: Payment method could not be deleted!": "Greška: Način plaćanja nije moguće izbrisati!",
		  "banks/financial instutions payments integrations": "integracije sa platim sistemima banaka i drugih finansijskih institucija",
		  "Add New Payment Method": "Dodaj novu metodu plaćanja",
		  "Platform Modules": "Platformski Moduli",
		  "Already have an account?": "Već imate nalog?",
		  "ID": "ID",
		  "Site Url": "Site Url",
		  "Additional Site Url-s": "Pomoćni url-ovi sajta",
		  "Date": "Datum",
		  "Please select site...": "Molimo izaberite sajt...",
		  "Please select a company": "Molimo izaberite firmu",
		  "Create new company...": "Kreiraj novu firmu...",
		  "No selected": "Nije izabrano",
		  "Selected Company": "Firma",
		  "--company not selected--": "--firma nije odabrana--",
		  "Selected POS": "Odabrani POS",
		  "Please Select POS": "Molimo odaberite POS",
		  "Add a new POS (site or app or split-pay identifier)...": "Dodaj novi POS (Sajt/Aplikaciju/SplitPay)",
		  "Site shipping method data saved!": "Podaci o načinu isporuke na sajtu su sačuvani!",
		  "Error saving site shipping method data": "Greška pri čuvanju podataka o načinu isporuke sajta",
		  "Shipping Methods": "Metode Isporuke",
		  "Shipping Method Configuration": "Konfiguracija metode isporuke",
		  "Remove shipping method": "Uklonite način isporuke",
		  "Please confirm you want remove shipping method": "Potvrdite da želite da uklonite način isporuke",
		  "Shipping method is deleted": "Način isporuke je izbrisan",
		  "Error: Shipping method could not be deleted!": "Greška: način isporuke nije moguće izbrisati!",
		  "Error loading POS shipping methods!": "Greška pri učitavanju POS metoda isporuke!",
		  "courier systems api integration": "API integracije sa sistemima kurirskih službi",
		  "Add New Shipping Method": "Dodaj metodu isporuke",
		  "POS was updated correctly!": "POS je uspešno ažuriran!",
		  "HOLEST PURCHASE KEY WAS NOT ACCEPTED!": "HOLEST KLJUČ PROIZVODA NIJE PRIVAĆEN!",
		  "POS type is not an site. You can not connect site to different POS types!": "Odabrani POS nije tipa sajt. Ne možete povezati sajt sa drugim tipovima POS-a.",
		  "Site to be connected must be main url or one of auxiliary urls for the selected POS!": "Sajt koji se povezuje mora biti glavni uri ili jedan od pomoćnih URI-ja za izabrani POS!",
		  "Error in site update request!": "Greška pri zahtevu ažuriranja!",
		  "Regenerate secret key": "Regenerišite tajni ključ",
		  "Please confirm you want to regenerate POS secret key": "Potvrdite da želite da ponovo generišete POS tajni ključ",
		  "You will lose connection with this POS untill you update secret key with it.": "Izgubićete vezu sa ovim POS dok ne ažurirate tajni ključ na njemu.",
		  "Delete site": "Obriši sajt",
		  "Please confirm you want to delete site": "Potvrdite da želite da izbrišete sajt",
		  "POS Configuration": "POS Konfiguracija",
		  "type": "tip",
		  "Standard": "Standardno",
		  "COMPANY": "FIRMA",
		  "URI/Indentifier": "URI/Identifikator",
		  "additional site url-s (one per line)": "pomoćni url-ovi sajta (jedan po liniji)",
		  "Merchant POS UID": "POS UID Trgovca",
		  "POS Secret Key": "POS Tajni Ključ",
		  "Re-generate": "Re-generiši",
		  "Instant payment/shipping/fiscal/integation notification url": "Link za instant notifikacije - plaćanje/isporuka/fiskal/integracije",
		  "Prefered exchange rate source": "Prefereca kursne liste",
		  "Exchange rate correction % (middle)": "Korekcija srednjeg kursa u %",
		  "Fixed language (for customers)": "Fiksirani jezik (za kupce)",
		  "Payment vault token saving policy (when available)": "Polisa čuvanja platnog tokena (kad je dostupno)",
		  "Leave as POS requested": "Ostavi kako je POS-a zahtevao",
		  "Never save": "Nikad ne čuvaj",
		  "Force required": "Postavi kao obavezno",
		  "Disable HPay Notifications": "Isključi HPay Notifikacije",
		  "If your site/POS can handle all customer messaging. Note that some messages are required by law!": "Ako samo prodajno mesto može poslati sve poruke kupcima. NAPOMENA: neke poruke su obavezne po zakonu!",
		  "Use your own SMTP to send customer notifications": "Koristi svoj SMTP za email notifikacije kupcima",
		  "Enable if you want to deliver HPay customer mails from your SMTP server. If send fails it will revert to HPay SMTP!": "Uključi ako želiš da se HPay notifikacije za kupce šalju sa tvog SMTP servera. Ako slanje ne uspe mailovi će biti poslati preko HPay SMTP-a",
		  "Enter proper SMTP settings!": "Unsite ispravna SMTP podešavanja!",
		  "Send test mail to": "Pošalji test mail na adresu",
		  "Send": "Pošalji",
		  "Test mail was sent however you must confirm successful reception by checking test address inbox!": "Test email poruka je poslata ali morate takođe proveriti da je prijem bio uspešan u inbox-u test mail adrese!",
		  "Error in test mail sending!": "Greška pri slanju test email poruke",
		  "Enter proper email address!": "Unesi ispravnu e-mail adresu!",
		  "TEST SMTP SEND": "POŠALJI TEST MAIL",
		  "SMTP Host": "SMTP Host",
		  "SMTP Port": "SMTP Port",
		  "SMTP Username": "SMTP Korisničko Ime",
		  "SMTP Password": "SMTP Lozinka",
		  "SMTP Security Protocol": "SMTP Sigurnosni Protokol",
		  "SSL": "SSL",
		  "TLS": "TLS",
		  "StartTLS": "StartTLS",
		  "SMTP From": "SMTP Od",
		  "SMTP From Name": "SMTP Naziv Pošiljaoca",
		  "SMTP Reply To": "SMTP Odgovor na",
		  "HOLEST Key (purchase key)": "HOLEST Ključ (dobija se pri kupovini)",
		  "Key expires at": "Ključ ističe",
		  "not needed for the sandbox mode": "nije potrebno za režim sandbox-a",
		  "key you bought on ecommerce.holest.com": "ključ koji ste kupili na https://ecommerce.holest.com",
		  "ACTIVATED": "AKTIVIRANO",
		  "Subscriptions": "Pretplate",
		  "Fiscal/integration/e-invoice": "Fiskal/integracije/e-fakture",
		  "Buy a new key...": "Kupi novi kljuć...",
		  "Customer support email": "Vaš e-mail za poršku kupcima",
		  "Customer support telephone": "Vaš telefon za poršku kupcima",
		  "Customer support notes": "Vaše napomene vezano za poršku kupcima",
		  "enter notes about your customer support": "unesite napomene vezano za poršku kupcima",
		  "Your payment terms link": "Link do Vaše strane sa uslovima kupovine",
		  "and choose...": "i odaberi...",
		  "POS uri": "POS uri",
		  "Auxiliary site url-s": "Pomoćni url-ovi sajta",
		  "Merchant POS uid": "UID POS-a trgovca",
		  "HOLESTKey exp.": "HOLESTKey istek",
		  "enter valid url": "unesite pravilan link",
		  "enter url": "unesite link",
		  "Selected site is deleted!": "Izabrani sajt je izbrisan!",
		  "Error during site delete": "Greška prilikom brisanja sajta",
		  "Error during POS delete": "Greška prilikom brisanja POS-a",
		  "Please correct your input!": "Ispravite svoj unos!",
		  "The POS is added successfully!": "POS je uspešno dodat!",
		  "Error during POS add": "Greška tokom POS dodavanja",
		  "sandbox: key not needed": "sandbox: ključ nije potreban",
		  "Please add a POS - Site, App or SplitPay.": "Dodajte POS - sajt, aplikaciju ili SplitPay.",
		  "Web site": "Web sajt",
		  "IOS/Android App": "IOS/Android Applikacija",
		  "Stand alone split-pay receiver": "SplitPay - samostani nalog za prijem uplata sa sajta partnera",
		  "POS: Sites or Apps or SplitPay receivers": "POS: Sajtovi ili Aplikacije ili samostalni SplitPay prijemnici",
		  "Add a new POS": "Dodaj novi POS",
		  "Add a POS for": "Dodajte POS za",
		  "POS type": "Tip POS-a",
		  "Standard type is for platforms where you install plugin/module like wooCommerce, OpenCart, Magento, etc..": "Standardni tip je za platforme gde instalate plugin/modul , npr. wooCommerce, OpenCart, Magento, itd..",
		  "Main site url": "Glavni url sajta",
		  "IOS/Android bundle id-s - comma separated": "ID-jevi identifikatora aplikacije za iOS/Android - odvojeni zarezima",
		  "Idenificator like": "Identifikator poput",
		  "install-air-conditioner": "instaliraj-klima-uređaj",
		  "donation-j.doe": "donacija-j.doe",
		  "joes-currier": "džoov-kurir",
		  "comma separated, without www. and https://": "odvojeno zarezom, bez www. i https://",
		  "NOTE: for registered sites and apps you can use site UID as split-pay identifier. You need a stand alone split-pay POS only when you don't have your site/app and you need to receive payments only through purhases over your partner's site(s).": "NAPOMENA: za registrovane sajtove i aplikacije možete koristiti UID sajta kao identifikator SplitPay-a. Potreban vam je samostalni POS sa UID-om za SplitPay samo kada nemate svoju web prodavnicu/aplikaciju te primate uplate samo putem kupovine preko sajta/sajtova partnera.",
		  "Subscription details...": "Detalji pretplate...",
		  "Issue": "Opis problema/Pitanje",
		  "Raised by": "Prijavio",
		  "Error loaging support ticket list": "Greška pri učitavanju liste zahteva za podršku",
		  "Date/Time": "Datum/Vreme",
		  "Issue description": "Opis problema",
		  "Concerning company": "Tiče se firme",
		  "Closed": "Zatvoreno",
		  "Error loading support ticket message": "Greška pri učitavanju poruke tiketa za podršku",
		  "Delete support ticket message": "Izbrišite poruku za podršku",
		  "Please confirm you want remove message": "Potvrdite da želite da uklonite poruku",
		  "Delete message": "Obriši poruku",
		  "Message deleted": "Poruka obrisna",
		  "Error: message could not be deleted!": "Greška: poruka nije mogla da se obriše!",
		  "Mark resolved": "Označi kao razrešeno",
		  "Please confirm you want mark this ticket as resolved": "Potvrdite da želite da označite ovj zahtev kao rešen",
		  "Close ticket": "Zatvori zahtev",
		  "Error: ticket could not be closed!": "Greška: zahtev nije mogao da se zatvori!",
		  "Support ticket": "Zahtevi za podrškom",
		  "Ticket time": "Vreme zahteva",
		  "This support ticket is resolved": "Ovaj zahtev je označen kao razrešen",
		  "Message/Issue Description": "Opis problema/poruka",
		  "at": "u",
		  "You must select a company so you could raise a new ticket concerning it": "Molimo odaberite firmu u vezi koje šaljete pitanje/zahtev",
		  "Support tickets": "Zahtevi za podrškom",
		  "Create a new support ticket": "Napravi zahtev za podrškom",
		  "Transaction details...": "Detalji transakcije...",
		  "ORDER ACTIONS": "AKCIJE ZA NARUDž.",
		  "Password updated": "Lozinka je promenjena",
		  "Error - password refused": "Greška - lozinka nije prohvaćena",
		  "Error - in password update request": "Greška pri zahtevu za promenu lozinke",
		  "Error - could not update the password": "Greška - lozinka nije mogla biti promenjena",
		  "Data updated": "Podaci su ažurirani",
		  "Error - could not update the data": "Greška podaci nisu mogli biti promenjeni",
		  "Error - refused": "Greška - zahtev odbijen",
		  "Error - in request": "Greška u zahtevu",
		  "Error - could not obtain credential parameters": "Greška - parametri kredencijala nisu dostupni",
		  "Remove biometric/webauthn credential": "Uklonite biometrijske/vebauthn akreditive",
		  "Please confirm you want remove credential": "Potvrdite da želite da uklonite akreditive",
		  "Credentials over external device added successfully": "Kredencijali preko eksternog uređaja su uspešno dodati",
		  "Enter current password": "Unesite trenutnu lozinku",
		  "No biometric/webauthn credetials exists. When identity verification is required HolestPay will revert method of sending you 6 digit security code over your e-mail. It's recommended thet you use more modern and secure biometric/webauthn methods since they don't involve trasmition of security parameters in clear form over channels that don't guarantee absolute security.": "Ne postoje biometrijski/WebAuthN akreditivi. Kada je potrebna verifikacija identiteta, HolestPay će primeniti metodu slanja 6-cifrenog sigurnosnog koda preko e-mail-a. Preporučuje se da koristite modernije i bezbednije biometrijske/WebAuthN metode jer one ne uključuju prenošenje bezbednosnih parametara u izvornom obliku preko kanala koji ne garantuju apsolutnu bezbednost.",
		  "Change password": "Promena lozinke",
		  "Pick a new password of at least 8 characters, at least one uppercase letter and at least one number": "Izaberite novu lozinku od najmanje 8 znakova, najmanje jednog velikog slova i najmanje jednog broja",
		  "Current password": "Trenutna lozinka",
		  "Add Biometric/WebAuthN Account Verification": "Dodaj Biometrisku/WebAuthN verifikaciju naloga",
		  "Face-Id and fingerprint are biometric credentials and they provide maximal level of reliability for in the process of your identity verification. It's recommended that you use biometric methods when available. Every browser, even on old PC/phone, will enable you to use basic PIN verification.": "Face-Id i otisak prsta su pravi biometrijske akreditivi i pružaju maksimalan nivo pouzdanosti u procesu verifikacije vašeg identiteta. Preporučuje se da koristite biometrijske metode kada su dostupne. Svaki pretraživač, čak i na starom računaru/telefonu, omogućiće vam da koristite osnovnu verifikaciju PIN-om.",
		  "Verification device selection": "Odabir verifikacionog uređaja",
		  "DISCLAMER": "ODRICANJE OD ODGOVORNOSTI",
		  "does not store or transmit": "ne skladišti ili transmituje",
		  "any of your biometric data like Face-Id or Fingerprint. This data is contained in your device OS, and process of verification itslelf is done by your device/PC. Upon successful verification your device will inform our system that your identity is confirmed by providing matching cryptographic signatures.": "bilo koji od vaših biometrijskih podataka kao što su Face-Id ili otisak prsta. Ovi podaci se nalaze u OS vašeg uređaja, a sam proces verifikacije obavlja vaš uređaj/računar. Nakon uspešne verifikacije, vaš uređaj će obavestiti naš sistem da je vaš identitet potvrđen pružanjem odgovarajućih kriptografskih potpisa.",
		  "Account settings": "Podešavanja naloga",
		  "Back to dashboard...": "Povratak na početnu stranu...",
		  "Add Biometric (Fingerprint, Face-Id or PIN) verification": "Dodaj Biometrisku (Otisak prsta, Face-Id ili PIN) verifikaciju",
		  "Biometric/WebAuthN credentials": "Biometriski/WebAuthN kredencijali",
		  "Device type": "Tip uređaja",
		  "Browser": "Pretraživač",
		  "Show path": "Pokaži putanju",
		  "Go to first page": "Idi na prvu stranicu",
		  "Go to last page": "Idi na poslednju stranicu",
		  "Go to next page": "Idi na sledeću stranicu",
		  "Go to previous page": "Idi na prethodnu stranicu",
		  "Rows per page:": "Redova po stranici:",
		  "of": "od",
		  "Empty": "Prazno",
		  "Clear": "Briši",
		  "Loading…": "Učitavanje…",
		  "No options": "Nema opcija",
		  "Pagination navigation": "Navigacija po stranicama",
		  "Go to": "Idi na",
		  "page": "stranicu",
		  "__LANGUAGE__": "Srpski",
		  "Sites/Apps/SplitPay receivers": "Sajtovi/Aplikacije/SplitPay",
		  "PAYMENT METHODS": "METHODE PLAĆANjA",
		  "TRANSACTIONS": "TRANSAKCIJE",
		  "SUBSCRIPTIONS": "PRETPLATE",
		  "PLATFORM MODULES": "PLATFORMSKI MODULI",
		  "TICKETS": "PODRŠKA - ZAHTEVI",
		  "HELP": "POMOĆ",
		  "DASHBOARD": "KOMANDNA TABLA",
		  "Additional Site Url-s (comma separated)": "Pomoćni url-ovi sajta (odvoji zarezom)",
		  "--not selected--": "--nije izabrano--",
		  "Site": "Web sajt",
		  "Select Company": "Izaberite firmu",
		  "Please Select Site": "Molimo izaberite Sajt",
		  "Select Site": "Izaberite Sajt",
		  "Back to list": "Povratak na listu firmi",
		  "Reset": "Resetovanje",
		  "The site is added to the company": "Novi sajt je dodat za firmu",
		  "Please add a site.": "Molimo kreirajte novi sajt.",
		  "Add a new site/app/split-pay identifier": "Dodaj novi Sajt/Aplikaciju/SplitPay",
		  "Site Details": "Detalji sajta",
		  "Return to site list": "Idi na listu sajtova",
		  "Site Secret": "Tajna ključ sajta",
		  "Site Key": "Ključ sajta",
		  "ReGenerate": "ReGeneriši",
		  "Action": "Akcije",
		  "Payment Method Name": "Naziv metode plaćanja",
		  "Add PaymentMethod": "Dodajte metodu plaćanja",
		  "Selected Payment Methods is added correctly": "Izabrani načini plaćanja su ispravno dodati",
		  "New Payment Methods": "Novi načini plaćanja",
		  "Payments": "Plaćanja",
		  "Transactions Details": "Detalji transakcije",
		  "UID": "UID",
		  "Subscriptions Details": "Detalji o pretplatama",
		  "Payment Methods Details": "Detalji o načiniu plaćanja",
		  "Ticket": "Zahtev za podrškom",
		  "New Ticket": "Novi zahtev",
		  "My Tickets": "Moje zahtevi",
		  "Remember me": "Zapamti me",
		  "First name required": "Ime je obavezno",
		  "Last name required": "Prezime je obavezno",
		  "Localizations": "Lokalizacije",
		  "PAYMENT METHOD LOCALIZATIONS": "LOKALIZACIJE METODE PLAĆANjA",
		  "Add Payment Method Localizations": "Dodajte lokalizaciju metode plaćanja",
		  "Search data...": "Pretraži podatke...",
		  "Localization": "Lokalizacija",
		  "Localization Details": "Detalji o lokalizaciji",
		  "Ticket Name": "Naslov zahteva za prodrškom",
		  "Ticket Details": "Detalji o zahtevu za prodrškom",
		  "Mark Resolved": "Označite kao rešeno",
		  "Selected Site": "Sajt",
		  "--site/app/split-pay not selected--": "--odaberite sajt/aplikaciju/split-pay--",
		  "COMPANY_NAME_EXISTS": "Već postoji registrovana firma sa ovim imenom! Zatražite od korisnika koji je kreirao firmu da vam odobri pristup!",
		  "SITE_EXISTS": "Ovaj sajt je već registrovan! Zatražite od korisnika koji je kreirao sajt da vam odobri pristup!",
		  "SITES/APPS/SplitPay-s": "SAJTOVI/APLIKACIJE/SplitPay",
		  "FISCAL/INTEGRATION MODULES": "FISKALNI/INTEGRACIONI MODULI",
		  "SHIPPING METHODS": "MODULI ZA ISPORUKU",
		  "ORDERS": "NARUDžBINE",
		  "SUPPORT TICKETS": "ZAHTEVI TEHNIČKOJ PODRŠĆI",
		  "Order ident.": "Narudžbina ident.",
		  "Fiscal/integration methods": "Fiskalne/integracione metode",
		  "Fallback Of": "Fallback Of",
		  "Additional url-s": "Pomoćne url adrese",
		  "Upload": "Otpremi",
		  "Shipping Method": "Metoda isporuke",
		  "SUBJECT": "NASLOV",
		  "Delete Support Ticket": "Obriši zahtev za podrškom",
		  "Intesa, AIK, Komercijalna(NLB), HALKBANK": "Intesa, AIK, Komercijalna(NLB), HALKBANK",
		  "Bilo koja banka u Republici Serbiji": "Bilo koja banka u Republici Srbiji",
		  "OTP, Raiffeisen, Unicredit ": "OTP, Raiffeisen, Unicredit ",
		  "ALT5PAY": "ALT5PAY",
		  "Unos kartice na samom sajtu i COF subskripcije": "Unos kartice na samom sajtu i COF subskripcije",
		  "E-commerce account with supported bank. Account type must be 3D+API": "E-commerce account with supported bank. Account type must be 3D+API",
		  "Generisanje QR koda za placanje iz aplikacije i ekvivalatne uplatnice": "Generisanje QR koda za placanje iz aplikacije i ekvivalatne uplatnice",
		  "Racun u bilo kojoj banci u Srbiji": "Racun u bilo kojoj banci u Srbiji",
		  "E-commerce account with supported bank": "E-commerce account with supported bank",
		  "Mogucnost placanja kriptovalutama za ino kupce. Vi mozete dobiti samo pravi USD|EUR|CAD nikako kriptovalutu (taj deo je u nadleznosti Alt5Pay-a). Zato nije potrebna nikakva poseba licenca i po zakonu ove uplate se sagledavaju na isti naćin kao i PayPal.": "Mogucnost placanja kriptovalutama za ino kupce. Vi mozete dobiti samo pravi USD|EUR|CAD nikako kriptovalutu (taj deo je u nadleznosti Alt5Pay-a). Zato nije potrebna nikakva poseba licenca i po zakonu ove uplate se sagledavaju na isti naćin kao i PayPal.",
		  "Morate imati otvoren nalog na alt5pay.com. Morate imati EUR|USD račun da bi mogli da dovučete uplate. ": "Morate imati otvoren nalog na alt5pay.com. Morate imati EUR|USD račun da bi mogli da dovučete uplate. ",
		  "Scan this QR code with your mobile phone in order of using your phone as external verification device": "Skenirajte ovaj QR kod svojim mobilnim telefonom kako biste svoj telefon koristili kao spoljni uređaj za verifikaciju",
		  "OS": "OS",
		  "Please set a company logo!": "Molimo otpremite logo sliku!",
		  "Support Ticket Details": "Detalji zahteva za podrškom",
		  "Back to sites list...": "Povratak na listu sajtova",
		  "Additional Site Url-s (one per line)": "Pomoćni url-ovi sajta (jedan po liniji)",
		  "Error during data loading": "Greška tokom učitavanja podataka",
		  "Error loading site shipping method data": "Greška pri učitavanju podataka o načinu isporuke sajta",
		  "Error loading site payment methods!": "Greška pri učitavanju načina plaćanja sajta!",
		  "The Shipping Methods is exist in this site": "Metode isporuke postoje na ovom sajtu",
		  "The fiscal/integration methods is exist in this site": "Fiskalni/integracioni metodi postoje na ovom sajtu",
		  "Please set a company logo": "Postavite logo kompanije",
		  "Please add a POS.": "Molimo dodajte POS.",
		  "password is required": "pristupna šifra je obavezna",
		  "HolestPay": "HolestPay",
		  "Idenificator like 'install-air-conditioner' or 'donation-j.doe' or 'joes-currier'": "Identifikator poput „instalacija-klima-uređaja“ ili „donation-j.doe“ ili „pera-isporuka-i-montaza“",
		  "You might lose important data releted to this site.": "Možda ćete izgubiti važne podatke koji se odnose na ovaj sajt.",
		  "Only one user can be POS 'creator' therefore current 'creator' will became 'admin'.": "Samo jedan nalog može biti vlasnik POS-a pa će zato trenutni 'vlasnik' postati 'admin'.",
		  "Error during changing of ther user role": "Greška pri promeni role naloga za POS",
		  "staff": "osoblje",
		  "hpay-support": "hpay podrška",
		  "bad value!": "loša vrednost!",
		  "Company Warehouses": "Magacini Firme",
		  "CREATE PAY-BY-LINK": "KREIRAJ PLAĆANjE-PO-LINKU",
		  "Exclude": "Izuzmi",
		  "Sent":"Poslato"
		}
	},
	mk:{
		translation: {
			"__LANGUAGE__": "Makedonski",
			"Dashboard": "Контролна табла",
			"Welcome!": "Добредојдовте!",
			"You have no company defined. Please first create a company or wait for the access invite!": "Ве молиме прво да внесете компанија или почекајте да ви додадат пристап за друга компанија!",
			"Confirm": "Потврди",
			"COMPANY": "КОМПАНИЈА",
			"Sites/Apps/SplitPay receivers": "Сајтови/Апликации/SplitPay",
			"PAYMENT METHODS": "МЕТОДИ НА ПЛАЌАЊЕ",
			"TRANSACTIONS": "ТРАНСАКЦИИ",
			"SUBSCRIPTIONS": "ПРЕТПЛАТИ",
			"PLATFORM MODULES": "ПЛАТФОРМСКИ МОДУЛИ",
			"TICKETS": "ПОДДРШКА - БАРАЊА",
			"HELP": "ПОМОШ",
			"DASHBOARD": "КОНТРОЛНА ТАБЛА",
			"Please select a company": "Ве молиме изберете компанија",
			"ID": "ID",
			"Main site url": "Главна url адреса на сајтот",
			"Additional Site Url-s": "Помошни url адреси на сајтот",
			"Additional Site Url-s (comma separated)": "Помошни url адреси на сајтот (одделени со запирка)",
			"Company Name": "Име на компанија",
			"Date": "Датум",
			"Company": "Компанија",
			"--not selected--": "--не е избрано--",
			"Site": "Веб сајт",
			"Select Company": "Изберете компанија",
			"Please Select Site": "Ве молиме изберете Сајт",
			"Select Site": "Изберете Сајт",
			"Please create a company": "Ве молиме додадете компанија прво",
			"ResNo": "Матичен број",
			"TaxNo": "Даночен број",
			"Address": "Адреса",
			"Country": "Држава",
			"Company Details": "Детали за компанијата",
			"Company data": "Податоци за компанијата",
			"Details": "Детали",
			"Back to list": "Враќање на листата на компании",
			"Update": "Зачувај",
			"Delete": "Избриши",
			"Create a company": "Додај нова компанија",
			"Too Short!": "Премногу кратко!",
			"Too Long!": "Премногу долго!",
			"Name is required": "Името е задолжително",
			"Reg Number required": "Потребен е регистарски број",
			"Tax Number required": "Даночниот број е задолжителен",
			"Country required": "Потребно е да се наведе земја",
			"Create": "Креирај",
			"Reset": "Ресетирање",
			"Address is required": "Адресата е задолжителна",
			"Not found": "Не е пронајдено",
			"Selected site is deleted!": "Избраниот сајт е избришан!",
			"The site is added to the company": "Новиот сајт е додаден за компанијата",
			"Please add a site.": "Ве молиме креирајте нов сајт.",
			"Sites/Apps/SplitPay receivers": "Сајтови/Апликации/SplitPay",
			"Add a new site/app/split-pay identifier": "Додај нов Сајт/Апликација/SplitPay",
			"Add a new POS (site or app or split-pay identifier)...": "Додај нов POS (Сајт/Апликација/SplitPay)",
			"Add a POS for": "Додадете POS за",
			"Save": "Зачувај",
			"Cancel": "Откажи",
			"Site Details": "Детали за сајтот",
			"Return to site list": "Оди на листата на сајтови",
			"Site Secret": "Таен клуч на сајтот",
			"Site Key": "Клуч на сајтот",
			"ReGenerate": "РеГенерирај",
			"Action": "Акции",
			"Payment Method Name": "Име на методот на плаќање",
			"Payment Methods": "Начини на плаќање",
			"Add PaymentMethod": "Додадете метод на плаќање",
			"Selected Payment Methods is added correctly": "Избраните начини на плаќање се додадени правилно",
			"New Payment Methods": "Нови начини на плаќање",
			"Payments": "Плаќања",
			"Payment Method": "Начин на плаќање",
			"Type": "Тип",
			"Status": "Статус",
			"Transactions": "Трансакции",
			"Transactions Details": "Детали за трансакцијата",
			"Name": "Име",
			"Amount": "Износ",
			"UID": "UID",
			"Subscriptions": "Претплати",
			"Subscriptions Details": "Детали за претплатите",
			"Payment Methods Details": "Детали за начинот на плаќање",
			"Platform Modules": "Платформски Модули",
			"Ticket": "Барање за поддршка",
			"New Ticket": "Ново барање",
			"My Tickets": "Мои барања",
			"Help": "Помош",
			"Link": "Линк",
			"Description": "Опис",
			"Home": "КОНТРОЛНА ТАБЛА",
			"Logout": "Одјави се",
			"Don’t have an account?": "Немате налог?",
			"Seamless site payments | Shipping Automation | Fiscalization": "Универзален платен систем за правни субјекти",
			"Email must be a valid email address": "Адресата на е-пошта мора да биде валидна адреса на е-пошта",
			"Email is required": "Е-поштата е задолжителна",
			"Password is required": "Лозинката е неопходна",
			"Email address": "Адреса на е-пошта",
			"Password": "Лозинка",
			"Repeat password" : "Потврда на лозинка",
			"Remember me": "Запамти ме",
			"Forgot password?": "Заборавивте лозинка?",
			"Login": "Пријави се",
			"Sign In FaceBook": "Facebook пријава",
			"Sign In Google": "Google пријава",
			"Already have an account?": "Веќе имате налог?",
			"Seamless site payments | Shipping Automation | Fiscalization": "Беспрекорен прием на уплати на сајтот | Автоматизација на достава | Фискализација",
			"OR": "ИЛИ",
			"First name required": "Името е задолжително",
			"Last name required": "Презимето е задолжително",
			"First name": "Име",
			"Last name": "Презиме",
			"Register": "Регистрирај се",
			"Logo upload": "Отпремање на лого",
			"Localizations": "Локализации",
			"PAYMENT METHOD LOCALIZATIONS": "ЛОКАЛИЗАЦИИ НА МЕТОДИТЕ НА ПЛАЌАЊЕ",
			"Add Payment Method Localizations": "Додадете локализација на методот на плаќање",
			"Search data...": "Пребарај податоци...",
			"Localization": "Локализација",
			"Localization Details": "Детали за локализацијата",
			"User": "Корисник",
			"Ticket Name": "Наслов на барањето за поддршка",
			"Ticket Details": "Детали за барањето за поддршка",
			"Mark Resolved" : "Означете како решено",
			"Send" : "Испрати",
			"Delete company":"Бришење на компанија",
			"Please confirm you want to delete company": "Ве молиме потврдете го бришењето на компанијата",
			"You might lose important data releted to this company.": "Може да изгубите важни податоци поврзани со оваа компанија.",
			"Selected Company": "Избрана Компанија",
			"Selected Site": "Избран Сајт",
			"Re-generate": "Повторно генерирај",
			"--company not selected--": "--компанија не е избрана--",
			"--site/app/split-pay not selected--": "--не е избран сајт/апликација/сплит-пеј--",
			"COMPANY_NAME_EXISTS": "Веќе постои регистрирана компанија со ова име! Побарајте од корисникот кој ја креирал компанијата да ви одобри пристап!",
			"SITE_EXISTS": "Овој сајт е веќе регистриран! Побарајте од корисникот кој го креирал сајтот да ви одобри пристап!",
			"Site Url": "URL на сајт",
			"Selected POS": "Избран ПОС",
			"Please Select POS": "Ве молиме изберете ПОС",
			"SITES/APPS/SplitPay-s": "САЈТОВИ/АПЛИКАЦИИ/СплитПеј",
			"FISCAL/INTEGRATION MODULES": "ФИСКАЛНИ/ИНТЕГРАЦИОНИ МОДУЛИ",
			"SHIPPING METHODS": "МЕТОДИ НА ИСПОРАКА",
			"ORDERS": "НАРАЧКИ",
			"SUPPORT TICKETS": "БАРАЊА ЗА ТЕХНИЧКА ПОДДРШКА",
			"Loading...": "Се вчитува...",
			"From date/time": "Од датум/време",
			"To date/time": "До датум/време",
			"search...": "пребарувај...",
			"Load": "Вчитај",
			"Close": "Затвори",
			"Uid": "Уид",
			"Ident.": "Идент.",
			"Order ident.": "Идент. на нарачка",
			"Created On": "Создадено на",
			"Customer": "Купувач",
			"Payment": "Плаќање",
			"Split pay": "Сплит пеј",
			"Nothing found": "Ништо не е пронајдено",
			"Fiscal/integration methods": "Фискални/интеграциони методи",
			"Fiscal/integration Methods": "Фискални/интеграциони методи",
			"Add New Fiscal/Integration Method": "Додај нов фискален/интеграционен метод",
			"Fiscal/integration method": "Фискален/интеграционен метод",
			"Enabled": "Овозможено",
			"List order": "Редослед на листа",
			"Fallback Of": "Резервна опција на",
			"Order": "Нарачка",
			"Payment methods": "Методи на плаќање",
			"Add New Payment Method": "Додај нов метод на плаќање",
			"No": "Не",
			"POS uri": "ПОС ури",
			"Additional url-s": "Дополнителни URL-адреси",
			"Merchant POS uid": "УИД на ПОС на трговецот",
			"HOLESTKey exp.": "Истек на HOLESTKey",
			"Web site": "Веб-страница",
			"IOS/Android App": "iOS/Android апликација",
			"Stand alone split-pay receiver": "Самостоен приемник за сплит-пеј",
			"POS: Sites or Apps or SplitPay receivers": "ПОС: Сајтови или апликации или приемници за сплит-пеј",
			"Add a new POS": "Додај нов ПОС",
			"POS type": "Тип на ПОС",
			"comma separated, without www. and https://": "одделени со запирка, без www. и https://",
			"sandbox: key not needed": "песок: клучот не е потребен",
			"Yes": "Да",
			"Create new company...": "Креирај нова компанија...",
			"Administrator": "Администратор",
			"Staff": "Персонал",
			"Back to companies list...": "Назад кон листата на компании...",
			"Company users": "Корисници на компанијата",
			"Telephone": "Телефон",
			"Role": "Улога",
			"Actions": "Акции",
			"Add user": "Додај корисник",
			"Add access for a user": "Додај пристап за корисник",
			"Add a user access for the company": "Додај пристап на корисник за компанијата",
			"Make sure that a user you are adding access for has an HolestPay account. If not please instruct him/her to create a account first.": "Проверете дали корисникот на кој му додавате пристап има HolestPay сметка. Ако нема, замолете го/ја прво да креира сметка.",
			"Email": "Е-пошта",
			"Remove access": "Отстрани пристап",
			"HPay Support": "HPay поддршка",
			"Yourself": "Вие самите",
			"Payment Method Configuration": "Конфигурација на метод на плаќање",
			"Back to site payment methods...": "Назад кон методите на плаќање на сајтот...",
			"LOCALIZATION": "ЛОКАЛИЗАЦИЈА",
			"[DEFAULT]": "[СТАНДАРДНО]",
			"Add": "Додај",
			"Language code": "Код на јазик",
			"2 letters code": "Код од 2 букви",
			"Upload": "Постави",
			"Shipping methods": "Методи на испорака",
			"Add New Shipping Method": "Додај нов метод на испорака",
			"Shipping Method": "Метод на испорака",
			"Subscription details...": "Детали за претплата...",
			"Orders": "Нарачки",
			"Shipping": "Испорака",
			"Fiscal": "Фискализација",
			"Support tickets": "Барања за поддршка",
			"Create a new support ticket": "Креирај ново барање за поддршка",
			"Date/Time": "Датум/Време",
			"Issue description": "Опис на проблемот",
			"Raised by": "Покренато од",
			"Concerning company": "Во врска со компанија",
			"Concerning POS": "Во врска со ПОС",
			"Open": "Отвори",
			"Support ticket": "Барање за поддршка",
			"Ticket time": "Време на барање",
			"Back to support tickets list...": "Назад кон листата на барања за поддршка...",
			"SUBJECT": "НАСЛОВ",
			"Delete Support Ticket": "Избриши барање за поддршка",
			"Message/Issue Description": "Опис на порака/проблем",
			"at": "во",
			"Delete message": "Избриши порака",
			"Select payment method to add...": "Изберете метод на плаќање за додавање...",
			"Payment Type": "Тип на плаќање",
			"Info": "Информации",
			"Recurring support": "Поддршка за повторливи плаќања",
			"Is instant?": "Дали е инстантно?",
			"HPay cardform": "HPay формулар за картичка",
			"Known banks/financial institutions": "Познати банки/финансиски институции",
			"Intesa, AIK, Komercijalna(NLB), HALKBANK": "Интеза, АИК, Комерцијална(НЛБ), ХАЛКБАНК",
			"Bilo koja banka u Republici Serbiji": "Било која банка во Република Србија",
			"OTP, Raiffeisen, Unicredit ": "OTP, Рајфајзен, Уникредит",
			"ALT5PAY": "ALT5PAY",
			"Unos kartice na samom sajtu i COF subskripcije": "Внесување на картичка на самиот сајт и COF претплати",
			"Requirements": "Барања",
			"E-commerce account with supported bank. Account type must be 3D+API": "Е-трговска сметка со поддржана банка. Типот на сметката мора да биде 3D+API",
			"ADD": "ДОДАЈ",
			"Generisanje QR koda za placanje iz aplikacije i ekvivalatne uplatnice": "Генерирање QR код за плаќање од апликација и еквивалентна уплатница",
			"Racun u bilo kojoj banci u Srbiji": "Сметка во било која банка во Србија",
			"E-commerce account with supported bank": "Е-трговска сметка со поддржана банка",
			"Mogucnost placanja kriptovalutama za ino kupce. Vi mozete dobiti samo pravi USD|EUR|CAD nikako kriptovalutu (taj deo je u nadleznosti Alt5Pay-a). Zato nije potrebna nikakva poseba licenca i po zakonu ove uplate se sagledavaju na isti naćin kao i PayPal.": "Можност за плаќање со криптовалути за странски купувачи. Вие можете да добиете само вистински USD|EUR|CAD, никако криптовалута (тој дел е во надлежност на Alt5Pay). Затоа не е потребна никаква посебна лиценца и според законот овие уплати се разгледуваат на ист начин како и PayPal.",
			"Morate imati otvoren nalog na alt5pay.com. Morate imati EUR|USD račun da bi mogli da dovučete uplate. ": "Морате да имате отворен налог на alt5pay.com. Морате да имате EUR|USD сметка за да можете да повлечете уплати.",
			"Change password": "Промена на лозинка",
			"Pick a new password of at least 8 characters, at least one uppercase letter and at least one number": "Изберете нова лозинка од најмалку 8 знаци, најмалку една голема буква и најмалку еден број",
			"New password": "Нова лозинка",
			"Repeat new password": "Повтори нова лозинка",
			"Add Biometric/WebAuthN Account Verification": "Додај Биометриска/WebAuthN верификација на налог",
			"Face-Id and fingerprint are biometric credentials and they provide maximal level of reliability for in the process of your identity verification. It's recommended that you use biometric methods when available. Every browser, even on old PC/phone, will enable you to use basic PIN verification.": "Face-Id и отпечаток од прст се вистински биометриски акредитиви и обезбедуваат максимално ниво на сигурност во процесот на верификација на вашиот идентитет. Се препорачува да користите биометриски методи кога се достапни. Секој прелистувач, дури и на стар компјутер/телефон, ќе ви овозможи да користите основна верификација со PIN.",
			"Verification device selection": "Избор на уред за верификација",
			"Use current browser": "Користи го тековниот прелистувач",
			"Scan this QR code with your mobile phone in order of using your phone as external verification device": "Скенирајте го овој QR код со вашиот мобилен телефон за да го користите вашиот телефон како надворешен уред за верификација",
			"Equivalent url": "Еквивалентна URL адреса",
			"DISCLAMER": "ОДРЕКУВАЊЕ ОД ОДГОВОРНОСТ",
			"does not store or transmit": "не складира или пренесува",
			"any of your biometric data like Face-Id or Fingerprint. This data is contained in your device OS, and process of verification itslelf is done by your device/PC. Upon successful verification your device will inform our system that your identity is confirmed by providing matching cryptographic signatures.": "ниту еден од вашите биометриски податоци како Face-Id или отпечаток од прст. Овие податоци се содржани во оперативниот систем на вашиот уред, а самиот процес на верификација се врши од вашиот уред/компјутер. По успешна верификација, вашиот уред ќе го информира нашиот систем дека вашиот идентитет е потврден со обезбедување соодветни криптографски потписи.",
			"Account settings": "Поставки на сметка",
			"Back to dashboard...": "Враќање на почетната страница...",
			"Add Biometric (Fingerprint, Face-Id or PIN) verification": "Додај Биометриска (Отпечаток од прст, Face-Id или PIN) верификација",
			"Biometric/WebAuthN credentials": "Биометриски/WebAuthN акредитиви",
			"Device type": "Тип на уред",
			"OS": "ОС",
			"Browser": "Прелистувач",
			"No biometric/webauthn credetials exists. When identity verification is required HolestPay will revert method of sending you 6 digit security code over your e-mail. It's recommended thet you use more modern and secure biometric/webauthn methods since they don't involve trasmition of security parameters in clear form over channels that don't guarantee absolute security.": "Не постојат биометриски/WebAuthN акредитиви. Кога е потребна верификација на идентитет, HolestPay ќе го врати методот на испраќање 6-цифрен безбедносен код преку вашата е-пошта. Се препорачува да користите посовремени и побезбедни биометриски/WebAuthN методи бидејќи тие не вклучуваат пренос на безбедносни параметри во јасна форма преку канали кои не гарантираат апсолутна безбедност.",
			"Passwords do not match": "Лозинките не се совпаѓаат",
			"Please enter correct email and password": "Ве молиме внесете точна е-пошта и лозинка",
			"No such user or bad password": "Не постои таков корисник или погрешна лозинка",
			"Service is currently unavailable. Please try later...": "Услугата е моментално недостапна. Ве молиме обидете се подоцна...",
			"Handshake session expired or not found": "Сесијата за ракување истече или не е пронајдена",
			"Data mismatch! Please retry registration from beginning!": "Несовпаѓање на податоци! Ве молиме обидете се повторно со регистрација од почеток!",
			"Password must meet complexity requirements": "Лозинката мора да ги задоволува критериумите за комплексност",
			"Password confirmation mismatch": "Несовпаѓање на потврда на лозинка",
			"You are temporarily blocked becuse of lot of request is a short time period. Try in a few minutes!": "Привремено сте блокирани поради голем број на барања во краток временски период. Обидете се за неколку минути!",
			"Access recovery": "Враќање на пристап",
			"Password reset": "Ресетирање на лозинка",
			"Enter your email, set a new password and confirm it. Then proceed to the identity verification.": "Внесете ја вашата е-пошта, поставете нова лозинка и потврдете ја. Потоа продолжете на чекорот за верификација на идентитет.",
			"Proceed to identity verification...": "Продолжи на верификација на идентитет...",
			"Remember me on this browser": "Запамти ме на овој прелистувач",
			"Upload blocked!": "Поставувањето е блокирано!",
			"Site payment method data saved!": "Податоците за начинот на плаќање на сајтот се зачувани!",
			"Updated!": "Ажурирано!",
			"Please set a company logo!": "Ве молиме поставете лого на компанијата!",
			"Please enter at least 8 characters": "Ве молиме внесете најмалку 8 знаци",
			"Please enter at least 1 number": "Ве молиме внесете најмалку 1 број",
			"Please enter at least 1 lowercase letter": "Ве молиме внесете најмалку 1 мала буква",
			"Please enter at least 1 uppercase letter": "Ве молиме внесете барем една голема буква",
			"Please enter at least 1 special character": "Ве молиме внесете барем еден специјален карактер",
			"Transaction details...": "Детали за трансакцијата...",
			"ACTIONS": "АКЦИИ",
			"Support Ticket Details": "Детали за барањето за поддршка",
			"This support ticket is resolved": "Ова барање за поддршка е решено",
			"enter valid url": "внесете валидна URL адреса",
			"enter url": "внесете URL адреса",
			"Auxiliary site url-s": "Помошни URL-адреси на сајтот",
			"NOTE: for registered sites and apps you can use site UID as split-pay identifier. You need a stand alone split-pay POS only when you don't have your site/app and you need to receive payments only through purhases over your partner's site(s).": "НАПОМЕНА: за регистрирани сајтови и апликации можете да го користите UID-от на сајтот како идентификатор за сплит-пеј. Потребен ви е самостоен ПОС за сплит-пеј само кога немате свој сајт/апликација и треба да примате плаќања само преку купувања преку сајтот/сајтовите на вашиот партнер.",
			"POS Configuration": "ПОС Конфигурација",
			"type": "тип",
			"Back to sites list...": "Враќање на листата на сајтови...",
			"URI/Indentifier": "URI/Идентификатор",
			"Additional Site Url-s (one per line)": "Помошни URL-адреси на сајтот (една по линија)",
			"additional site url-s (one per line)": "помошни URL-адреси на сајтот (една по линија)",
			"Merchant POS UID": "UID на ПОС на трговецот",
			"POS Secret Key": "Таен клуч на ПОС",
			"Prefered exchange rate source": "Префериран извор на курсна листа",
			"Exchange rate correction % (middle)": "Корекција на среден курс во %",
			"HOLEST Key (purchase key)": "HOLEST Клуч (се добива при купување)",
			"Key expires at": "Клучот истекува на",
			"Shipping Method Configuration": "Конфигурација на метод на испорака",
			"Back to site shipping methods...": "Враќање на листата на методи на испорака...",
			"Fallback of": "Резервна опција на",
			"none": "ништо",
			"Order details...": "Детали за нарачката...",
			"Raise a new support ticket": "Креирај ново барање за поддршка",
			"Support tickets are way to make sure our support receives your support request (since email can be unreliable sometimes). Please allow our team at least 24h to respond.": "Барањата за поддршка се начин да се осигурате дека нашата поддршка ќе го добие вашето барање (бидејќи е-поштата понекогаш може да биде несигурна). Ве молиме дозволете му на нашиот тим најмалку 24 часа да одговори.",
			"You will be able to describe your problem after ticket creation.": "Ќе можете да го опишете вашиот проблем по креирањето на барањето.",
			"Please name your issue": "Ве молиме насловете го вашиот проблем",
			"Concerning Company": "Во врска со компанијата",
			"Fiscal/integration method configuration": "Конфигурација на фискален/интеграционен метод",
			"Back to site fiscal/integration methods...": "Врати се на листата на фискални/интеграциони методи...",
			"Select shipping method to add...": "Изберете фискален метод за додавање...",
			"Select fiscal/integration method to add...": "Изберете фискален/интеграционен метод за додавање...",
			"Please enter valid email address": "Ве молиме внесете валидна адреса на е-пошта",
			"You can close this window": "Можете да го затворите овој прозорец/страница",
			"Identity verification required": "Потребна е верификација на идентитет",
			"Biometric/WebAuthN verification device selection": "Избор на уред за биометриска/WebAuthN верификација",
			"Scan this QR code with your mobile phone if you are using your phone as external verification device": "Скенирајте го овој QR код со вашиот мобилен телефон ако го користите телефонот како надворешен уред за верификација",
			"Try different identity verification method...": "Обидете се со друг метод за верификација на идентитет...",
			"E-mail address verification pending...": "Се чека на потврда на адресата на е-пошта преку код од е-пошта...",
			"Please check your mailbox for 6-digit security code we sent you. Don't forget to check SPAM/Trash/Junk folders also if you don't find a mail message containing security code in your primary inbox.": "Проверете го вашето поштенско сандаче за 6-цифрениот безбедносен код што ви го испративме. Не заборавајте да ги проверите и папките SPAM/Trash/Junk ако не најдете е-пошта со безбедносен код во вашето главно поштенско сандаче.",
			"SECURITY CODE": "БЕЗБЕДНОСЕН КОД",
			"Cancel and return to the registration form...": "Откажи и врати се на формуларот за регистрација...",
			"Account data": "Податоци за сметка",
			"Biometric/WebAuthN Identity Protection": "Биометриска/WebAuthN заштита на идентитет",
			"Recommended": "Препорачано",
			"Upon registration setup biometric/webauthn credentials": "По регистрацијата, поставете биометриски/webauthn акредитиви (отпечаток од прст, face-id...)",
			"Password updated": "Лозинката е променета",
			"Error - password refused": "Грешка - лозинката е одбиена",
			"Error - in password update request": "Грешка во барањето за промена на лозинка",
			"Error - could not update the password": "Грешка - лозинката не можеше да биде променета",
			"Data updated": "Податоците се ажурирани",
			"Error - could not update the data": "Грешка - податоците не можеа да бидат променети",
			"Error - refused": "Грешка - барањето е одбиено",
			"Error - in request": "Грешка во барањето",
			"Error - could not obtain credential parameters": "Грешка - параметрите на акредитивите не се достапни",
			"Credentials over external device added successfully": "Акредитивите преку надворешен уред се успешно додадени",
			"Could not obtain credentials!": "Грешка - акредитивите не се достапни!",
			"Could not load payment methods definition": "Дефинициите на начините на плаќање не се вчитани!",
			"Could not load shipping methods definition": "Дефинициите на методите на испорака не се вчитани!",
			"Could not load fiscal/integration methods definition": "Дефинициите на фискалните/интеграционите методи не се вчитани!",
			"Error during data loading!": "Грешка при вчитувањето на податоците!",
			"Please select a POS!": "Ве молиме изберете ПОС!",
			"You must select a company so you could raise a new ticket concerning it": "Мора да изберете компанија за да можете да поднесете ново барање во врска со неа",
			"Message deleted": "Пораката е избришана",
			"Error: message could not be deleted!": "Грешка: пораката не можеше да се избрише!",
			"Error: ticket could not be closed!": "Грешка: барањето не можеше да се затвори!",
			"Error loaging support ticket list": "Грешка при вчитувањето на листата на барања за поддршка",
			"Error during site delete": "Грешка при бришењето на сајтот",
			"Error during POS delete": "Грешка при бришењето на ПОС",
			"Please correct your input!": "Исправете го вашиот влез!",
			"The POS is added successfully!": "ПОС е успешно додаден!",
			"Error during POS add": "Грешка при додавањето на ПОС",
			"Please add a POS - Site, App or SplitPay.": "Додадете ПОС - Сајт, Апликација или SplitPay.",
			"Error during data loading": "Грешка при вчитувањето на податоците",
			"Shipping method is deleted": "Начинот на испорака е избришан",
			"Error: Shipping method could not be deleted!": "Грешка: начинот на испорака не можеше да се избрише!",
			"Error loading POS shipping methods!": "Грешка при вчитувањето на ПОС методи на испорака!",
			"Site shipping method data saved!": "Податоците за начинот на испорака на сајтот се зачувани!",
			"Error saving site shipping method data": "Грешка при зачувувањето на податоците за начинот на испорака на сајтот",
			"Bad language code. Please use 2-letters code, optionally with extension -cyr!": "Лош код на јазик. Ве молиме користете код од 2 букви, опционално со екстензија -cyr!",
			"Error loading site shipping method data": "Грешка при вчитувањето на податоците за начинот на испорака на сајтот",
			"Please select site...": "Ве молиме изберете сајт...",
			"Payment method is deleted": "Начинот на плаќање е избришан",
			"Error: Payment method could not be deleted!": "Грешка: Начинот на плаќање не можеше да се избрише!",
			"Error loading site payment methods!": "Грешка при вчитувањето на начините на плаќање на сајтот!",
			"Error saving site payment method data": "Грешка при зачувувањето на податоците за начинот на плаќање на сајтот",
			"Error during support ticket creation": "Грешка при креирањето на тикет за поддршка",
			"Please Select Company": "Ве молиме изберете компанија",
			"Fiscal/integration method is deleted": "Фискалниот/интеграциониот метод е избришан",
			"Error: fiscal/integration method could not be deleted!": "Грешка: Фискалниот метод не можеше да се избрише!",
			"Error loading site fiscal/integration methods!": "Грешка при вчитувањето на фискалните методи на сајтот!",
			"Site fiscal/integration method data saved!": "Податоците за фискалниот метод на сајтот се зачувани!",
			"Error saving site fiscal/integration method data": "Грешка при зачувувањето на податоците за фискалниот метод на сајтот",
			"Error loading site fiscal/integration method data": "Грешка при вчитувањето на податоците за фискалниот/интеграциониот метод на сајтот",
			"Error during adding of this shipping method!": "Грешка при додавањето на овој начин на испорака!",
			"Error: could not add this shipping method at the moment!": "Грешка: во моментов не е можно да се додаде овој начин на испорака!",
			"The Shipping Methods is exist in this site": "Методите на испорака постојат на овој сајт",
			"Error during adding of this payment method!": "Грешка при додавањето на овој начин на плаќање!",
			"Error: could not add this payment method at the moment!": "Грешка: во моментов не е можно да се додаде овој начин на плаќање!",
			"Error during adding of this fiscal/integration method!": "Грешка при додавањето на овој фискален/интеграционен метод!",
			"Error: could not add this fiscal/integration method at the moment!": "Грешка: во моментов не е можно да се додаде овој фискален метод!",
			"The fiscal/integration methods is exist in this site": "Фискалните/интеграционите методи постојат на овој сајт",
			"Please set a company logo": "Поставете лого на компанијата",
			"The company created successfully!": "Компанијата е успешно креирана!",
			"Error during company create": "Грешка при креирањето на компанијата",
			"Please use .jpg or .png image": "Ве молиме користете .jpg или .png слика",
			"Error on data load!": "Грешка при вчитувањето на податоците!",
			"Error on data update!": "Грешка при ажурирањето на податоците!",
			"Error on data delete!": "Грешка при бришењето на податоците!",
			"Error during access removal": "Грешка при отстранувањето на пристапот",
			"User with given email was not found": "Корисник со дадена е-пошта не е пронајден",
			"You can not manage yourself": "Не можете да управувате со себе",
			"Error adding access for user": "Грешка при додавањето пристап за корисник",
			"Error changing user role": "Грешка при промената на улогата на корисникот",
			"External-device identity verification completed!": "Верификацијата на идентитет преку надворешен уред е завршена!",
			"Could not complete identity verification over external-device": "Није могуће завршити верификацију идентитета преко спољног уређаја",
			"Biometric/WebAuthN verification failed. You can try other verfication method...": "Биометријска/WebAuthN верификација није успела. Можете испробати други метод верификације...",
			"Could not obtain credentials! Try reverting to verification over e-mailed security code...": "Није могуће добити акредитиве! Покушајте да се вратите на верификацију преко безбедносног кода послатог е-поштом...",
			"Biometric/WebAuthN credentials approval on external device...": "Одобравање биометријских/WebAuthN акредитива на спољном уређају...",
			"Biometric/WebAuthN authorization over an external device...": "Биометријска/WebAuthN ауторизација преко спољног уређаја...",
			"Non-valid/unrecognised request!": "Неважећи/непрепознат захтев!",
			"New order": "Нова наруџбина",
			"New subscription": "Нова претплата",
			"Please add a POS.": "Молимо додајте ПОС.",
			"Identity verification": "Верификација идентитета",
			"Error! Please try again or later...": "Грешка! Покушајте поново или касније...",
			"Could not perform Biometric/WebAuthN verification!": "Није могуће извршити биометријску/WebAuthN верификацију!",
			"Account data is accepted. You must verify your email address before we finalize you account creation. Please check you email for security code we sent you.": "Подаци о налогу су прихваћени. Морате да верификујете своју адресу е-поште пре него што завршимо креирање вашег налога. Проверите своју е-пошту за безбедносни код који смо вам послали.",
			"Bad response please retry or try later...": "Лош одговор, покушајте поново или покушајте касније...",
			"first name is required": "име је обавезно",
			"last name is required": "презиме је обавезно",
			"email is required": "е-маил је обавезан",
			"password is required": "приступна шифра је обавезна",
			"confrimation of password is required": "потребна је потврда лозинке",
			"Customer support email": "Ваш е-маил за подршку купцима",
			"Customer support telephone": "Ваш телефон за подршку купцима",
			"Customer support notes": "Ваше напомене везано за подршку купцима",
			"enter notes about your customer support": "унесите напомене везано за подршку купцима",
			"Your payment terms link": "Линк до Ваше стране са условима куповине",
			"HolestPay": "HolestPay",
			"Remove biometric/webauthn credential": "Уклоните биометријске/вебаутхн акредитиве",
			"Please confirm you want remove credential": "Потврдите да желите да уклоните акредитиве",
			"Remove": "Уклони",
			"Delete support ticket message": "Избришите поруку за подршку",
			"Please confirm you want remove message": "Потврдите да желите да уклоните поруку",
			"Mark resolved": "Означи као разрешено",
			"Please confirm you want mark this ticket as resolved": "Потврдите да желите да означите овај захтев као решен",
			"Close ticket": "Затвори захтев",
			"Closed": "Затворено",
			"Issue": "Опис проблема/Питање",
			"IOS/Android bundle id-s - comma separated": "ID-јеви идентификатора апликације за iOS/Android - одвојени зарезима",
			"Idenificator like 'install-air-conditioner' or 'donation-j.doe' or 'joes-currier'": "Идентификатор попут „инсталација-клима-уређаја“ или „donation-j.doe“ или „пера-испорука-и-монтаза“",
			"Delete site": "Обриши сајт",
			"Please confirm you want to delete site": "Потврдите да желите да избришете сајт",
			"You might lose important data releted to this site.": "Можда ћете изгубити важне податке који се односе на овај сајт.",
			"not needed for the sandbox mode": "није потребно за режим sandbox-а",
			"key you bought on ecommerce.holest.com": "кључ који сте купили на https://ecommerce.holest.com",
			"Regenerate secret key": "Регенеришите тајни кључ",
			"Please confirm you want to regenerate POS secret key": "Потврдите да желите да поново генеришете ПОС тајни кључ",
			"You will lose connection with this POS untill you update secret key with it.": "Изгубићете везу са овим ПОС док не ажурирате тајни кључ на њему.",
			"Remove shipping method": "Уклоните начин испоруке",
			"Please confirm you want remove shipping method": "Потврдите да желите да уклоните начин испоруке",
			"You may lose important data by deleting this method.": "Можете изгубити важне податке брисањем овог метода.",
			"Remove localization": "Уклоните локализацију",
			"Please confirm you want remove localization": "Потврдите да желите да уклоните локализацију",
			"No selected": "Није изабрано",
			"Remove payment method": "Уклоните начин плаћања",
			"Please confirm you want remove payment method": "Потврдите да желите да уклоните начин плаћања",
			"Remove fiscal/integration method": "Уклоните фискални/интеграциони метод",
			"Please confirm you want remove fiscal/integration method": "Потврдите да желите да уклоните фискални/интеграциони метод",
			"access to": "приступ",
			"Set role: staff": "Рола -> особље",
			"Set role: admin": "Рола -> админ",
			"Set role: owner": "Рола -> власник",
			"Please confirm you want change role of": "Молимо потврдите промену роле за",
			"to":"у",
			"Set new role":"Постави нову ролу",
			"Only one user can be POS 'creator' therefore current 'creator' will became 'admin'.": "Само један корисник може бити 'креатор' ПОС-а, стога ће тренутни 'креатор' постати 'админ'.",
			"Error during changing of ther user role": "Грешка при промени роле налога за ПОС",
			"Change POS user role": "Промена роле налога за ПОС",
			"staff": "особље",
			"admin": "админ",
			"creator": "власник",
			"hpay-support":"hpay подршка",
			"Remove user access": "Уклоните приступ корисника",
			"Please confirm you want to remove": "Потврдите да желите да уклоните",
			"Remove Access": "Уклоните приступ",
			"Please check you email for security code we sent you.": "Проверите своју е-пошту за безбедносни код који смо вам послали.",
			"Reverting to verification over e-mailed security code...": "Враћање на верификацију преко безбедносног кода послатог е-поштом...",
			"enter valid email": "Унесите исправну е-пошту",
			"Please correct your input": "Исправите свој унос",
			"Bad email address": "Лоша адреса е-поште",
			"Bad first or last name": "Лоше име или презиме",
			"Specified email already exists": "Наведена адреса е-поште већ постоји",
			"too short?": "прекратко?",
			"too long?": "предуго?",
			"Waiting for authorization...": "Чекање на ауторизацију...",
			"Company selection/registration...": "Избор/регистрација фирме...",
			"Site selection/registration...": "Избор/регистрација сајта...",
			"POS was updated correctly!": "ПОС је успешно ажуриран!",
			"Error in site update request!": "Грешка при захтеву ажурирања!",
			"and choose...": "и одабери...",
			"POS type is not an site. You can not connect site to different POS types!": "Одабрани ПОС није типа сајт. Не можете повезати сајт са другим типовима ПОС-а.",
			"Connected!": "Повезано!",
			"ACTIVATED": "АКТИВИРАНО",
			"HOLEST PURCHASE KEY WAS NOT ACCEPTED!": "HOLEST КЉУЧ ПРОИЗВОДА НИЈЕ ПРИХВАЋЕН!",
			"Buy a new key...": "Купи нови кључ...",
			"Fiscal/integration/e-invoice": "Фискал/интеграције/е-фактуре",
			"Site to be connected must be main url or one of auxiliary urls for the selected POS!": "Сајт који се повезује мора бити главни УРИ или један од помоћних УРИ-ја за изабрани ПОС!",
			"bad value!": "лоша вредност!",
			"Shipping Methods": "Методе Испоруке",
			"fiscal/e-invoice tax system integration, embedded devices (like carwash coin machines) or external system notifications (production line intstructions)": "интеграција са пореским системом фискал/е-фактура, нотификације за специјализоване уређаје (попут машина за жетоне код аутоперионица) или нотификација ка другим системима (нпр. пошаљи налог фабрици)",
			"courier systems api integration": "АПИ интеграције са системима курирских служби",
			"banks/financial instutions payments integrations": "интеграције са платим системима банака и других финансијских институција",
			"Instant payment/shipping/fiscal/integation notification url": "Линк за инстант нотификације - плаћање/испорука/фискал/интеграције",
			"Fixed language (for customers)": "Фиксирани језик (за купце)",
			"Payment vault token saving policy (when available)": "Полиса чувања платног токена (кад је доступно)",
			"Leave as POS requested": "Остави како је ПОС захтевао",
			"Never save": "Никад не чувај",
			"Force required": "Постави као обавезно",
			"Method UID": "УИД методе",
			"Process Group": "Процесна група",
			"If multiple methods belong to same process group after one in order generates result rest of them are skipped.": "Уколико више метода припада истој процесној групи, и када једна у редоследу генерише резултат извршење осталих се прескаче",
			"Should be unique! If you need to re-create POS method (because any reason) it's important you keep this value same": "Треба бити уникатна вредност! Уколико морате да ре-креирате методу за ПОС (из било ког разлога) важно је да ова вредност остане иста",
			"ORDER ACTIONS": "АКЦИЈЕ ЗА НАРУЏ.",
			"Show path": "Покажи путању",
			"Go to": "Иди на",
			"Go to first page": "Иди на прву страницу",
			"Go to last page": "Иди на последњу страницу",
			"Go to next page": "Иди на следећу страницу",
			"Go to previous page": "Иди на претходну страницу",
			"page": "страницу",
			"of": "од",
			"Empty": "Празно",
			"Clear": "Бриши",
			"Close": "Затвори",
			"Loading…": "Учитавање…",
			"No options": "Нема опција",
			"Open": "Отвори",
			"Pagination navigation": "Навигација по страницама",
			"Rows per page:": "Редова по страници:",
			"Company Warehouses": "Магацини Фирме",
			"Identifier": "Идентификатор",
			"Postal Code": "Поштански број",
			"Street Name": "Назив улице",
			"Street Number": "Број у улици",
			"important if you use shipping": "битно ако користите модуле за испоруку",
			"Default": "Подразумевано",
			"Disable HPay Notifications": "Искључи HPay Нотификације",
			"Enter current password": "Унесите тренутну лозинку",
			"Current password": "Тренутна лозинка",
			"If your site/POS can handle all customer messaging. Note that some messages are required by law!": "Ако само продајно место може послати све поруке купцима. НАПОМЕНА: неке поруке су обавезне по закону!",
			"Use your own SMTP to send customer notifications": "Користи свој SMTP за емаил нотификације купцима",
			"Enable if you want to deliver HPay customer mails from your SMTP server. If send fails it will revert to HPay SMTP!": "Укључи ако желиш да се HPay нотификације за купце шаљу са твог SMTP сервера. Ако слање не успе мејлови ће бити послати преко HPay SMTP-а",
			"Send test mail to": "Пошаљи тест мејл на адресу",
			"TEST SMTP SEND": "ПОШАЉИ ТЕСТ МЕЈЛ",
			"Enter proper email address!": "Унеси исправну е-маил адресу!",
			"SMTP Password": "SMTP Лозинка",
			"SMTP Username": "SMTP Корисничко Име",
			"SMTP Security Protocol": "SMTP Сигурносни Протокол",
			"SMTP From Name": "SMTP Назив Пошиљаоца",
			"Enter proper SMTP settings!":"Унсите исправна SMTP подешавања!",
			"Error in test mail sending!":"Грешка при слању тест email поруке",
			"Test mail was sent however you must confirm successful reception by checking test address inbox!":"Test email порука је послата али морате такође проверити да је пријем био успешан у inbox-у test mail адресе!",
			"Standard type is for platforms where you install plugin/module like wooCommerce, OpenCart, Magento, etc..": "Стандардни тип је за платформе где инсталирате plugin/modul , нпр. wooCommerce, OpenCart, Magento, итд..",
			"Standard":"Стандардно",
			"CREATE PAY-BY-LINK": "КРЕИРАЈ ПЛАЌАЊЕ-СО-ВРСКА",
			"Exclude": "Исклучи",
			"Sent":"Испратено",
			"Expires": "Истекува"
		 }
		
	}
};

HPAY_TRANSLATION.languages = [];


const CYR = "А,а,Б,б,Ц,ц,Ч,ч,Ћ,ћ,Д,д,Џ,џ,Ђ,ђ,Е,е,Ф,ф,Г,г,Х,х,И,и,Ј,ј,К,к,Л,л,Љ,љ,М,м,Н,н,Њ,њ,О,о,П,п,Р,р,С,с,Ш,ш,Т,т,У,у,В,в,З,з,Ж,ж".split(",");
const LAT = "A,a,B,b,C,c,Č,č,Ć,ć,D,d,Dž,dž,Đ,đ,E,e,F,f,G,g,H,h,I,i,J,j,K,k,L,l,Lj,lj,M,m,N,n,Nj,nj,O,o,P,p,R,r,S,s,Š,š,T,t,U,u,V,v,Z,z,Ž,ž".split(",");
const LATCYR = {};
LAT.forEach((l, index) => {
	LATCYR[l] = CYR[index];
});
HPAY_TRANSLATION.transliterate_lat_cyr = (str) => { 
	if(!str) return str; 
	LAT.filter(c => c.length > 1).forEach(c => {
			str = str.replaceAll(c,LATCYR[c]);
		});
	return str.split("").map(l => LATCYR[l] ? LATCYR[l] : l).join("").replaceAll('ХПаy','HPay').replaceAll('ПЦИ ДСС','PCI DSS').replaceAll('ПЦИ ДСС','PCI DSS').replaceAll('ХОЛЕСТ Е-ЦОММЕРЦЕ ДОО','HOLEST E-COMMERCE DOO').replaceAll('ХОЛЕСТ','HOLEST').replaceAll('ХОЛЕСТ','HOLEST');
};
HPAY_TRANSLATION.rs_cyr = {translation:{}};
for(let phrase in HPAY_TRANSLATION.rs.translation){
	if(HPAY_TRANSLATION.rs.translation.hasOwnProperty(phrase)){
		HPAY_TRANSLATION.rs_cyr.translation[phrase] = HPAY_TRANSLATION.transliterate_lat_cyr(HPAY_TRANSLATION.rs.translation[phrase]);
	}
}

for(let lng in HPAY_TRANSLATION){
	if(HPAY_TRANSLATION.hasOwnProperty(lng)){
		if(HPAY_TRANSLATION[lng].translation){
			HPAY_TRANSLATION.languages.push(lng);
		}
	}
}

//Object.assign(exports,HPAY_TRANSLATION);//UNCOMMENT WHEN RUNNING SCAN TRANSLATIONS
export default HPAY_TRANSLATION;
